import { $t as e, At as t, Bn as n, C as r, Dt as i, Et as a, H as o, Mn as s, On as c, Qt as l, Tt as u, Wt as d, Xn as f, _n as p, _t as m, an as h, bn as g, cn as ee, en as te, f as ne, gn as _, hn as v, in as re, jt as ie, kt as ae, mt as y, on as b, pn as x, rn as oe, sn as se, t as ce, un as le, vn as S, wt as ue, yt as de, zn as C } from "./blocks-CpMAs3pB.js";
import { r as fe, t as pe } from "./BlockNoteExtension-BXhE27K9.js";
import { C as me, D as he, E as ge, O as _e, S as ve, T as ye, _ as be, d as xe, f as Se, k as Ce, l as we, m as Te, n as Ee, o as De, p as Oe, t as ke, u as Ae, v as je, w as Me, x as Ne, y as w } from "./extensions-B0znnrCE.js";
import { t as Pe } from "./ShowSelection-S5WeiRyI.js";
import { t as Fe } from "./en-B9hMApn4.js";
import { t as Ie } from "./EventEmitter-CuPnGDYt.js";
import { DOMParser as Le, DOMSerializer as Re, Fragment as T, Node as ze, NodeRange as Be, Slice as E } from "prosemirror-model";
import { ReplaceAroundStep as D, ReplaceStep as Ve, canJoin as He, liftTarget as Ue } from "prosemirror-transform";
import { Editor as We, Extension as O, Mark as k, Node as A, combineTransactionSteps as Ge, createDocument as Ke, extensions as j, findChildrenInRange as qe, findParentNodeClosestToPos as Je, getAttributes as Ye, getChangedRanges as Xe, getMarkRange as Ze, getMarksBetween as Qe, getSchema as $e, isNodeSelection as et, markPasteRule as tt, mergeAttributes as M, posToDOMRect as nt, selectionToInsertionEnd as rt } from "@tiptap/core";
import { NodeSelection as N, Plugin as P, TextSelection as F } from "prosemirror-state";
import { Fragment as I, Slice as L } from "@tiptap/pm/model";
import { CellSelection as it, TableMap as at } from "prosemirror-tables";
import { Plugin as ot, PluginKey as st } from "@tiptap/pm/state";
import ct from "remark-gfm";
import { unified as lt } from "unified";
import ut from "remark-parse";
import dt, { defaultHandlers as ft } from "remark-rehype";
import pt from "rehype-stringify";
import { InputRule as mt, inputRules as ht } from "@handlewithcare/prosemirror-inputrules";
import { keymap as gt } from "@tiptap/pm/keymap";
import { Gapcursor as _t } from "@tiptap/extensions/gap-cursor";
import { Text as vt } from "@tiptap/extension-text";
//#region src/schema/contentTypes/combinators/types.ts
var yt = {
	inline: () => ({ kind: "inline" }),
	none: () => ({ kind: "none" }),
	record: (e) => ({
		kind: "record",
		fields: e
	}),
	list: (e, t = {}) => ({
		kind: "list",
		item: e,
		...t.min === void 0 ? {} : { min: t.min }
	}),
	blocks: (e = {}) => ({
		kind: "blocks",
		...e.min === void 0 ? {} : { min: e.min }
	}),
	props: (e, t) => ({
		kind: "props",
		propSchema: e,
		content: t
	})
};
//#endregion
//#region src/schema/contentTypes/combinators/factory.ts
function bt(e, t) {
	let n = R(t, e, !0, {});
	return {
		name: e,
		containerNode: n.tiptapNode,
		innerNodes: n.innerNodes,
		nodeToJSON(e, n) {
			return z(t, e, n);
		},
		jsonToNodes(n, r) {
			return xt(t, n, r, e);
		},
		toJSON() {
			return {
				__contentType: e,
				schema: t
			};
		}
	};
}
function R(e, t, n, r) {
	switch (e.kind) {
		case "inline": return {
			tiptapNode: A.create({
				name: t,
				content: "inline*",
				isolating: !0,
				...n ? { group: "blockContent" } : {},
				addAttributes() {
					return c(r);
				},
				parseHTML() {
					return [{ tag: `[data-content-name="${t}"]` }];
				},
				renderHTML({ HTMLAttributes: e }) {
					return [
						"div",
						{
							...e,
							"data-content-name": t
						},
						0
					];
				}
			}),
			contentExpressionAtom: t,
			innerNodes: []
		};
		case "none": return {
			tiptapNode: A.create({
				name: t,
				content: "",
				isolating: !0,
				...n ? { group: "blockContent" } : {},
				addAttributes() {
					return c(r);
				},
				parseHTML() {
					return [{ tag: `[data-content-name="${t}"]` }];
				},
				renderHTML({ HTMLAttributes: e }) {
					return ["div", {
						...e,
						"data-content-name": t
					}];
				}
			}),
			contentExpressionAtom: t,
			innerNodes: []
		};
		case "record": {
			let i = Object.entries(e.fields).map(([e, n]) => ({
				fieldName: e,
				compiled: R(n, `${t}__${e}`, !1, {})
			})), a = i.map((e) => e.compiled.contentExpressionAtom).join(" "), o = i.flatMap((e) => [e.compiled.tiptapNode, ...e.compiled.innerNodes]);
			return {
				tiptapNode: A.create({
					name: t,
					content: a,
					isolating: !0,
					...n ? { group: "blockContent" } : {},
					addAttributes() {
						return c(r);
					},
					parseHTML() {
						return [{ tag: `[data-content-name="${t}"]` }];
					},
					renderHTML({ HTMLAttributes: e }) {
						return [
							"div",
							{
								...e,
								"data-content-name": t
							},
							0
						];
					}
				}),
				contentExpressionAtom: t,
				innerNodes: o
			};
		}
		case "list": {
			let i = e.item, a = R(i, `${t}__item`, !1, {}), o = (e.min ?? 0) >= 1 ? "+" : "*", s = `${a.contentExpressionAtom}${o}`;
			return {
				tiptapNode: A.create({
					name: t,
					content: s,
					isolating: !0,
					...n ? { group: "blockContent" } : {},
					addAttributes() {
						return c(r);
					},
					parseHTML() {
						return [{ tag: `[data-content-name="${t}"]` }];
					},
					renderHTML({ HTMLAttributes: e }) {
						return [
							"div",
							{
								...e,
								"data-content-name": t
							},
							0
						];
					}
				}),
				contentExpressionAtom: t,
				innerNodes: [a.tiptapNode, ...a.innerNodes]
			};
		}
		case "blocks": {
			let i = `blockContainer${(e.min ?? 0) >= 1 ? "+" : "*"}`;
			return {
				tiptapNode: A.create({
					name: t,
					content: i,
					isolating: !0,
					...n ? { group: "blockContent" } : {},
					addAttributes() {
						return c(r);
					},
					parseHTML() {
						return [{ tag: `[data-content-name="${t}"]` }];
					},
					renderHTML({ HTMLAttributes: e }) {
						return [
							"div",
							{
								...e,
								"data-content-name": t
							},
							0
						];
					}
				}),
				contentExpressionAtom: t,
				innerNodes: []
			};
		}
		case "props": return R(e.content, t, n, {
			...r,
			...e.propSchema
		});
	}
}
function z(e, t, n) {
	switch (e.kind) {
		case "inline": return n.contentNodeToInlineContent(t);
		case "none": return;
		case "record": {
			let r = {};
			return Object.entries(e.fields).forEach(([e, i], a) => {
				r[e] = z(i, t.child(a), n);
			}), r;
		}
		case "list": {
			let r = e.item, i = [];
			for (let e = 0; e < t.childCount; e++) i.push(z(r, t.child(e), n));
			return i;
		}
		case "blocks": {
			let e = [];
			for (let r = 0; r < t.childCount; r++) e.push(n.nodeToBlock(t.child(r)));
			return e;
		}
		case "props": {
			let r = {};
			for (let n of Object.keys(e.propSchema)) r[n] = t.attrs[n];
			return {
				props: r,
				content: z(e.content, t, n)
			};
		}
	}
}
function xt(e, t, n, r) {
	let i = B(e, t, n, r);
	return Array.from({ length: i.childCount }, (e, t) => i.child(t));
}
function B(e, t, n, r, i = {}) {
	let a = n.schema.nodes[r];
	if (!a) throw Error(`Combinator content type expected ProseMirror node "${r}" but it isn't registered. Did you forget to register the content type's inner nodes?`);
	switch (e.kind) {
		case "inline": {
			let e = n.inlineContentToNodes(t, r);
			return a.createChecked(i, e);
		}
		case "none": return a.createChecked(i);
		case "record": {
			let o = Object.entries(e.fields).map(([e, i]) => {
				let a = t[e];
				return B(i, a, n, `${r}__${e}`);
			});
			return a.createChecked(i, o);
		}
		case "list": {
			let o = e.item, s = `${r}__item`, c = (t ?? []).map((e) => B(o, e, n, s));
			return a.createChecked(i, c);
		}
		case "blocks": {
			let e = (t ?? []).map((e) => n.blockToNode(e));
			return a.createChecked(i, e);
		}
		case "props": {
			let a = t, o = {
				...i,
				...a.props ?? {}
			};
			return B(e.content, a.content, n, r, o);
		}
	}
}
//#endregion
//#region src/schema/inlineContent/createSpec.ts
function St(e, t) {
	let n = [{
		tag: `[data-inline-content-type="${e.type}"]`,
		contentElement: (e) => {
			let t = e;
			return t.matches("[data-editable]") ? t : t.querySelector("[data-editable]") || t;
		}
	}];
	return t && n.push({
		tag: "*",
		getAttrs(e) {
			if (typeof e == "string") return !1;
			let n = t?.(e);
			return n === void 0 ? !1 : n;
		}
	}), n;
}
function Ct(t, n) {
	return te(A.create({
		name: t.type,
		inline: !0,
		group: "inline",
		draggable: n.meta?.draggable,
		selectable: t.content === "styled",
		atom: t.content === "none",
		content: t.content === "styled" ? "inline*" : "",
		addAttributes() {
			return c(t.propSchema);
		},
		addKeyboardShortcuts() {
			return e(t);
		},
		parseHTML() {
			return St(t, n.parse);
		},
		renderHTML({ node: e }) {
			let r = this.options.editor;
			return l(n.render.call({
				renderType: "dom",
				props: void 0
			}, se(e, r.schema.inlineContentSchema, r.schema.styleSchema), () => {}, r), t.type, e.attrs, t.propSchema);
		},
		addNodeView() {
			return (e) => {
				let { node: r, getPos: i } = e, a = this.options.editor;
				return l(n.render.call({
					renderType: "nodeView",
					props: e
				}, se(r, a.schema.inlineContentSchema, a.schema.styleSchema), (e) => {
					let t = ie([e], a.pmSchema), n = i();
					n && a.transact((e) => e.replaceWith(n, n + r.nodeSize, t));
				}, a), t.type, r.attrs, t.propSchema);
			};
		}
	}), t.propSchema, {
		...n,
		toExternalHTML: n.toExternalHTML,
		render(e, r, i) {
			return l(n.render(e, r, i), t.type, e.props, t.propSchema);
		}
	});
}
//#endregion
//#region src/api/blockManipulation/commands/insertBlocks/insertBlocks.ts
function wt(e, n, r, a = "before") {
	let o = typeof r == "string" ? r : r.id, s = x(e), c = n.map((e) => t(e, s)), l = i(o, e.doc);
	if (!l) throw Error(`Block with ID ${o} not found`);
	let u = l.posBeforeNode;
	return a === "after" && (u += l.node.nodeSize), e.step(new Ve(u, u, new E(T.from(c), 0, 0))), c.map((e) => b(e, s));
}
//#endregion
//#region src/api/blockManipulation/commands/replaceBlocks/util/fixColumnList.ts
function V(e) {
	if (!e || e.type.name !== "column") throw Error("Invalid columnPos: does not point to column node.");
	let t = e.firstChild;
	if (!t) throw Error("Invalid column: does not have child node.");
	let n = t.firstChild;
	if (!n) throw Error("Invalid blockContainer: does not have child node.");
	return e.childCount === 1 && t.childCount === 1 && n.type.name === "paragraph" && n.content.content.length === 0;
}
function Tt(e, t) {
	let n = e.doc.resolve(t), r = n.nodeAfter;
	if (!r || r.type.name !== "columnList") throw Error("Invalid columnListPos: does not point to columnList node.");
	for (let t = r.childCount - 1; t >= 0; t--) {
		let r = e.doc.resolve(n.pos + 1).posAtIndex(t), i = e.doc.resolve(r).nodeAfter;
		if (!i || i.type.name !== "column") throw Error("Invalid columnPos: does not point to column node.");
		V(i) && e.delete(r, r + i.nodeSize);
	}
}
function H(e, t) {
	Tt(e, t);
	let n = e.doc.resolve(t).nodeAfter;
	if (!n || n.type.name !== "columnList") throw Error("Invalid columnListPos: does not point to columnList node.");
	if (n.childCount > 2) return;
	if (n.childCount < 2) throw Error("Invalid columnList: contains fewer than two children.");
	let r = t + 1, i = e.doc.resolve(r).nodeAfter, a = t + n.nodeSize - 1, o = e.doc.resolve(a).nodeBefore;
	if (!i || !o) throw Error("Invalid columnList: does not contain children.");
	let s = V(i), c = V(o);
	if (s && c) {
		e.delete(t, t + n.nodeSize);
		return;
	}
	if (s) {
		e.step(new D(t, t + n.nodeSize, a - o.nodeSize + 1, a - 1, E.empty, 0, !1));
		return;
	}
	if (c) {
		e.step(new D(t, t + n.nodeSize, r + 1, r + i.nodeSize - 1, E.empty, 0, !1));
		return;
	}
}
//#endregion
//#region src/api/blockManipulation/commands/replaceBlocks/replaceBlocks.ts
function U(e, n, r) {
	let i = x(e), a = r.map((e) => t(e, i)), o = new Set(n.map((e) => typeof e == "string" ? e : e.id)), s = [], c = /* @__PURE__ */ new Set(), l = typeof n[0] == "string" ? n[0] : n[0].id, u = 0;
	if (e.doc.descendants((t, n) => {
		if (o.size === 0) return !1;
		if (!t.type.isInGroup("bnBlock") || !o.has(t.attrs.id)) return !0;
		if (s.push(b(t, i)), o.delete(t.attrs.id), r.length > 0 && t.attrs.id === l) {
			let t = e.doc.nodeSize;
			e.insert(n, a);
			let r = e.doc.nodeSize;
			u += t - r;
		}
		let d = e.doc.nodeSize, f = e.doc.resolve(n - u);
		f.node().type.name === "column" ? c.add(f.before(-1)) : f.node().type.name === "columnList" && c.add(f.before()), f.node().type.name === "blockGroup" && f.node(f.depth - 1).type.name !== "doc" && f.node().childCount === 1 ? e.delete(f.before(), f.after()) : e.delete(n - u, n - u + t.nodeSize);
		let p = e.doc.nodeSize;
		return u += d - p, !1;
	}), o.size > 0) {
		let e = [...o].join("\n");
		throw Error("Blocks with the following IDs could not be found in the editor: " + e);
	}
	return c.forEach((t) => H(e, t)), {
		insertedBlocks: a.map((e) => b(e, i)),
		removedBlocks: s
	};
}
//#endregion
//#region src/api/exporters/html/util/serializeBlocksInternalHTML.ts
function Et(e, t, n, r, i) {
	if (!t) throw Error("blockContent is required");
	let a = ae(t, e.pmSchema, r ?? "paragraph"), o = (i?.document ?? document).createDocumentFragment();
	for (let t of a) if (t.type.name !== "text" && e.schema.inlineContentSchema[t.type.name]) {
		let r = e.schema.inlineContentSpecs[t.type.name].implementation;
		if (r) {
			let a = se(t, e.schema.inlineContentSchema, e.schema.styleSchema), s = r.render.call({
				renderType: "dom",
				props: void 0
			}, a, () => {}, e);
			if (s) {
				if (o.appendChild(s.dom), s.contentDOM) {
					let e = n.serializeFragment(t.content, i);
					s.contentDOM.dataset.editable = "", s.contentDOM.appendChild(e);
				}
				continue;
			}
		}
	} else if (t.type.name === "text") {
		let n = document.createTextNode(t.textContent);
		for (let r of t.marks.toReversed()) if (r.type.name in e.schema.styleSpecs) {
			let t = e.schema.styleSpecs[r.type.name].implementation.render(r.attrs.stringValue, e);
			t.contentDOM.appendChild(n), n = t.dom;
		} else {
			let e = r.type.spec.toDOM(r, !0), t = Re.renderSpec(document, e);
			t.contentDOM.appendChild(n), n = t.dom;
		}
		o.appendChild(n);
	} else {
		let e = n.serializeFragment(T.from([t]), i);
		o.appendChild(e);
	}
	return o;
}
function Dt(e, t, n, r) {
	let i = e.pmSchema.nodes.blockContainer, a = t.props || {};
	for (let [n, r] of Object.entries(e.schema.blockSchema[t.type].propSchema)) !(n in a) && r.default !== void 0 && (a[n] = r.default);
	let o = t.children || [], s = e.blockImplementations[t.type].implementation.render.call({
		renderType: "dom",
		props: void 0
	}, {
		...t,
		props: a,
		children: o
	}, e);
	if (s.contentDOM && t.content) {
		let i = Et(e, t.content, n, t.type, r);
		s.contentDOM.appendChild(i);
	}
	if (e.pmSchema.nodes[t.type].isInGroup("bnBlock")) {
		if (t.children && t.children.length > 0) {
			let i = Ot(e, t.children, n, r);
			s.contentDOM?.append(i);
		}
		return s.dom;
	}
	let c = i.spec?.toDOM?.(i.create({
		id: t.id,
		...a
	}));
	return c.contentDOM?.appendChild(s.dom), t.children && t.children.length > 0 && c.contentDOM?.appendChild(kt(e, t.children, n, r)), c.dom;
}
function Ot(e, t, n, r) {
	let i = (r?.document ?? document).createDocumentFragment();
	for (let a of t) {
		let t = Dt(e, a, n, r);
		i.appendChild(t);
	}
	return i;
}
var kt = (e, t, n, r) => {
	let i = e.pmSchema.nodes.blockGroup, a = i.spec.toDOM(i.create({})), o = Ot(e, t, n, r);
	return a.contentDOM?.appendChild(o), a.dom;
}, At = (e) => (e.querySelectorAll("[data-content-type=\"numberedListItem\"]").forEach((e) => {
	let t = e.closest(".bn-block-outer")?.previousElementSibling?.querySelector("[data-content-type=\"numberedListItem\"]");
	if (!t) e.setAttribute("data-index", e.getAttribute("data-start") || "1");
	else {
		let n = t.getAttribute("data-index");
		e.setAttribute("data-index", (parseInt(n || "0") + 1).toString());
	}
}), e), jt = (e) => (e.querySelectorAll("[data-content-type=\"checkListItem\"] input").forEach((e) => {
	e.disabled = !0;
}), e), Mt = (e) => (e.querySelectorAll(".bn-toggle-wrapper[data-show-children=\"false\"]").forEach((e) => {
	e.setAttribute("data-show-children", "true");
}), e), Nt = (e) => (e.querySelectorAll("[data-content-type=\"table\"] table").forEach((e) => {
	e.setAttribute("style", "--default-cell-min-width: 120px;"), e.setAttribute("data-show-children", "true");
}), e), Pt = (e) => (e.querySelectorAll("[data-content-type=\"table\"] table").forEach((e) => {
	let t = document.createElement("div");
	t.className = "tableWrapper";
	let n = document.createElement("div");
	n.className = "tableWrapper-inner", t.appendChild(n), e.parentElement?.appendChild(t), t.appendChild(e);
}), e), Ft = (e) => (e.querySelectorAll(".bn-inline-content:empty").forEach((e) => {
	let t = document.createElement("span");
	t.className = "ProseMirror-trailingBreak", t.setAttribute("style", "display: inline-block;"), e.appendChild(t);
}), e), It = (e, t) => {
	let n = Re.fromSchema(e), r = [
		At,
		jt,
		Mt,
		Nt,
		Pt,
		Ft
	];
	return { serializeBlocks: (e, i) => {
		let a = kt(t, e, n, i);
		for (let e of r) a = e(a);
		return a.outerHTML;
	} };
};
//#endregion
//#region src/api/blockManipulation/commands/moveBlocks/moveBlocks.ts
function Lt(e) {
	return e.transact((e) => {
		let t = g(e.doc, e.selection.anchor);
		if (e.selection instanceof it) return {
			type: "cell",
			anchorBlockId: t.node.attrs.id,
			anchorCellOffset: e.selection.$anchorCell.pos - t.posBeforeNode,
			headCellOffset: e.selection.$headCell.pos - t.posBeforeNode
		};
		if (e.selection instanceof N) return {
			type: "node",
			anchorBlockId: t.node.attrs.id
		};
		{
			let n = g(e.doc, e.selection.head);
			return {
				type: "text",
				anchorBlockId: t.node.attrs.id,
				headBlockId: n.node.attrs.id,
				anchorOffset: e.selection.anchor - t.posBeforeNode,
				headOffset: e.selection.head - n.posBeforeNode
			};
		}
	});
}
function Rt(e, t) {
	let n = i(t.anchorBlockId, e.doc)?.posBeforeNode;
	if (n === void 0) throw Error(`Could not find block with ID ${t.anchorBlockId} to update selection`);
	let r;
	if (t.type === "cell") r = it.create(e.doc, n + t.anchorCellOffset, n + t.headCellOffset);
	else if (t.type === "node") r = N.create(e.doc, n + 1);
	else {
		let a = i(t.headBlockId, e.doc)?.posBeforeNode;
		if (a === void 0) throw Error(`Could not find block with ID ${t.headBlockId} to update selection`);
		r = F.create(e.doc, n + t.anchorOffset, a + t.headOffset);
	}
	e.setSelection(r);
}
function W(e) {
	return e.map((e) => e.type === "columnList" ? e.children.map((e) => W(e.children)).flat() : {
		...e,
		children: W(e.children)
	}).flat();
}
function zt(e, t, n) {
	e.transact((r) => {
		let i = e.getSelection()?.blocks || [e.getTextCursorPosition().block], a = Lt(e);
		e.removeBlocks(i), e.insertBlocks(W(i), t, n), Rt(r, a);
	});
}
function Bt(e) {
	return !e || e.type !== "columnList";
}
function Vt(e, t, n) {
	let r, i;
	if (t ? t.children.length > 0 ? (r = t.children[t.children.length - 1], i = "after") : (r = t, i = "before") : n && (r = n, i = "before"), !r || !i) return;
	let a = e.getParentBlock(r);
	return Bt(a) ? {
		referenceBlock: r,
		placement: i
	} : Vt(e, i === "after" ? r : e.getPrevBlock(r), a);
}
function Ht(e, t, n) {
	let r, i;
	if (t ? t.children.length > 0 ? (r = t.children[0], i = "before") : (r = t, i = "after") : n && (r = n, i = "after"), !r || !i) return;
	let a = e.getParentBlock(r);
	return Bt(a) ? {
		referenceBlock: r,
		placement: i
	} : Ht(e, i === "before" ? r : e.getNextBlock(r), a);
}
function Ut(e) {
	e.transact(() => {
		let t = e.getSelection()?.blocks[0] || e.getTextCursorPosition().block, n = Vt(e, e.getPrevBlock(t), e.getParentBlock(t));
		n && zt(e, n.referenceBlock, n.placement);
	});
}
function Wt(e) {
	e.transact(() => {
		let t = e.getSelection(), n = t?.blocks[t?.blocks.length - 1] || e.getTextCursorPosition().block, r = Ht(e, e.getNextBlock(n), e.getParentBlock(n));
		r && zt(e, r.referenceBlock, r.placement);
	});
}
//#endregion
//#region src/api/blockManipulation/commands/nestBlock/nestBlock.ts
function Gt(e, t, n) {
	let { $from: r, $to: i } = e.selection, a = r.blockRange(i, (e) => e.childCount > 0 && (e.type.name === "blockGroup" || e.type.name === "column"));
	if (!a) return !1;
	let o = a.startIndex;
	if (o === 0) return !1;
	let s = a.parent.child(o - 1);
	if (s.type !== t) return !1;
	let c = s.lastChild && s.lastChild.type === n, l = T.from(c ? t.create() : null), u = new E(T.from(t.create(null, T.from(n.create(null, l)))), c ? 3 : 1, 0), d = a.start, f = a.end;
	return e.step(new D(d - (c ? 3 : 1), f, d, f, u, 1, !0)).scrollIntoView(), !0;
}
function Kt(e) {
	return e.transact((t) => Gt(t, e.pmSchema.nodes.blockContainer, e.pmSchema.nodes.blockGroup));
}
function qt(e, t, n, r) {
	let i = r.end, a = r.$to.end(r.depth);
	if (i < a) {
		let o = r.parent.child(r.endIndex - 1), s = o.lastChild && o.lastChild.type === n;
		e.step(new D(i - (s ? 2 : 1), a, i, a, new E(T.from(t.create(null, n.create())), s ? 2 : 1, 0), +!s, !0)), r = new Be(e.doc.resolve(r.$from.pos), e.doc.resolve(a), r.depth);
	}
	let o = Ue(r);
	if (o == null) return !1;
	e.lift(r, o);
	let s = e.doc.resolve(e.mapping.map(i, -1) - 1);
	return He(e.doc, s.pos) && s.nodeBefore.type === s.nodeAfter.type && e.join(s.pos), e.scrollIntoView(), !0;
}
function G(e, t, n) {
	let { $from: r, $to: i } = e.selection, a = r.blockRange(i, (e) => e.childCount > 0 && (e.type.name === "blockGroup" || e.type.name === "column"));
	return a && r.node(a.depth - 1).type === t ? qt(e, t, n, a) : !1;
}
function Jt(e) {
	return e.transact((t) => G(t, e.pmSchema.nodes.blockContainer, e.pmSchema.nodes.blockGroup));
}
function Yt(e) {
	return e.transact((e) => {
		let { bnBlock: t } = S(e);
		return e.doc.resolve(t.beforePos).nodeBefore !== null;
	});
}
function Xt(e) {
	return e.transact((e) => {
		let { bnBlock: t } = S(e);
		return e.doc.resolve(t.beforePos).depth > 1;
	});
}
//#endregion
//#region src/api/blockManipulation/getBlock/getBlock.ts
function Zt(e, t) {
	let n = typeof t == "string" ? t : t.id, r = x(e), a = i(n, e);
	if (a) return b(a.node, r);
}
function Qt(e, t) {
	let n = i(typeof t == "string" ? t : t.id, e), r = x(e);
	if (!n) return;
	let a = e.resolve(n.posBeforeNode).nodeBefore;
	if (a) return b(a, r);
}
function $t(e, t) {
	let n = i(typeof t == "string" ? t : t.id, e), r = x(e);
	if (!n) return;
	let a = e.resolve(n.posBeforeNode + n.node.nodeSize).nodeAfter;
	if (a) return b(a, r);
}
function en(e, t) {
	let n = typeof t == "string" ? t : t.id, r = x(e), a = i(n, e);
	if (!a) return;
	let o = e.resolve(a.posBeforeNode), s = o.node(), c = o.node(-1), l = c.type.name === "doc" ? void 0 : s.type.name === "blockGroup" ? c : s;
	if (l) return b(l, r);
}
//#endregion
//#region src/editor/managers/BlockManager.ts
var tn = class {
	constructor(e) {
		this.editor = e;
	}
	get document() {
		return this.editor.transact((e) => h(e.doc, this.editor.pmSchema));
	}
	getBlock(e) {
		return this.editor.transact((t) => Zt(t.doc, e));
	}
	getPrevBlock(e) {
		return this.editor.transact((t) => Qt(t.doc, e));
	}
	getNextBlock(e) {
		return this.editor.transact((t) => $t(t.doc, e));
	}
	getParentBlock(e) {
		return this.editor.transact((t) => en(t.doc, e));
	}
	forEachBlock(e, t = !1) {
		let n = this.document.slice();
		t && n.reverse();
		function r(n) {
			for (let i of n) if (e(i) === !1 || !r(t ? i.children.slice().reverse() : i.children)) return !1;
			return !0;
		}
		r(n);
	}
	insertBlocks(e, t, n = "before") {
		return this.editor.transact((r) => wt(r, e, t, n));
	}
	updateBlock(e, t) {
		return this.editor.transact((n) => ue(n, e, t));
	}
	removeBlocks(e) {
		return this.editor.transact((t) => U(t, e, []).removedBlocks);
	}
	replaceBlocks(e, t) {
		return this.editor.transact((n) => U(n, e, t));
	}
	canNestBlock() {
		return Yt(this.editor);
	}
	nestBlock() {
		Kt(this.editor);
	}
	canUnnestBlock() {
		return Xt(this.editor);
	}
	unnestBlock() {
		Jt(this.editor);
	}
	moveBlocksUp() {
		return Ut(this.editor);
	}
	moveBlocksDown() {
		return Wt(this.editor);
	}
}, nn = class extends Ie {
	constructor(e) {
		super(), this.editor = e, e.on("create", () => {
			e._tiptapEditor.on("update", ({ transaction: t, appendedTransactions: n }) => {
				this.emit("onChange", {
					editor: e,
					transaction: t,
					appendedTransactions: n
				});
			}), e._tiptapEditor.on("selectionUpdate", ({ transaction: t }) => {
				this.emit("onSelectionChange", {
					editor: e,
					transaction: t
				});
			}), e._tiptapEditor.on("mount", () => {
				this.emit("onMount", { editor: e });
			}), e._tiptapEditor.on("unmount", () => {
				this.emit("onUnmount", { editor: e });
			});
		});
	}
	onChange(e, t = !0) {
		let n = ({ transaction: n, appendedTransactions: r }) => {
			!t && rn(n) || e(this.editor, { getChanges() {
				return _e(n, r);
			} });
		};
		return this.on("onChange", n), () => {
			this.off("onChange", n);
		};
	}
	onSelectionChange(e, t = !1) {
		let n = (n) => {
			!t && rn(n.transaction) || e(this.editor);
		};
		return this.on("onSelectionChange", n), () => {
			this.off("onSelectionChange", n);
		};
	}
	onMount(e) {
		return this.on("onMount", e), () => {
			this.off("onMount", e);
		};
	}
	onUnmount(e) {
		return this.on("onUnmount", e), () => {
			this.off("onUnmount", e);
		};
	}
};
function rn(e) {
	return !!e.getMeta("y-sync$");
}
//#endregion
//#region src/api/parsers/html/util/nestedLists.ts
function an(e) {
	return Array.prototype.indexOf.call(e.parentElement.childNodes, e);
}
function on(e) {
	return e.nodeType === 3 && !/\S/.test(e.nodeValue || "");
}
function sn(e) {
	e.querySelectorAll("li > ul, li > ol").forEach((e) => {
		let t = an(e), n = e.parentElement, r = Array.from(n.childNodes).slice(t + 1);
		e.remove(), r.forEach((e) => {
			e.remove();
		}), n.insertAdjacentElement("afterend", e), r.reverse().forEach((t) => {
			if (on(t)) return;
			let n = document.createElement("li");
			n.append(t), e.insertAdjacentElement("afterend", n);
		}), n.childNodes.length === 0 && n.remove();
	});
}
function cn(e) {
	e.querySelectorAll("li + ul, li + ol").forEach((e) => {
		let t = e.previousElementSibling, n = document.createElement("div");
		t.insertAdjacentElement("afterend", n), n.append(t);
		let r = document.createElement("div");
		for (r.setAttribute("data-node-type", "blockGroup"), n.append(r); n.nextElementSibling?.nodeName === "UL" || n.nextElementSibling?.nodeName === "OL";) r.append(n.nextElementSibling);
	});
}
var ln = null;
function un() {
	return ln ||= document.implementation.createHTMLDocument("title");
}
function dn(e) {
	if (typeof e == "string") {
		let t = un().createElement("div");
		t.innerHTML = e, e = t;
	}
	return sn(e), cn(e), e;
}
//#endregion
//#region src/api/parsers/html/util/normalizeWhitespace.ts
function fn(e) {
	let t = e.ownerDocument.createTreeWalker(e, 128), n;
	for (; n = t.nextNode();) if (/^\s*notionvc:/.test(n.nodeValue || "")) return !0;
	return !1;
}
function pn(e) {
	let t = new Set(["PRE", "CODE"]), n = e.ownerDocument.createTreeWalker(e, 4, { acceptNode(n) {
		let r = n.parentElement;
		for (; r && r !== e;) {
			if (t.has(r.tagName)) return 2;
			r = r.parentElement;
		}
		return 1;
	} }), r = [], i;
	for (; i = n.nextNode();) r.push(i);
	for (let e of r) e.nodeValue && /[\r\n]/.test(e.nodeValue) && (e.nodeValue = e.nodeValue.replace(/[ \t\r\n\f]+/g, " "));
}
function mn(e) {
	fn(e) || pn(e);
}
//#endregion
//#region src/api/parsers/html/parseHTML.ts
function K(e, t) {
	let n = dn(e);
	mn(n);
	let r = Le.fromSchema(t).parse(n, { topNode: t.nodes.blockGroup.create() }), i = [];
	for (let e = 0; e < r.childCount; e++) i.push(b(r.child(e), t));
	return i;
}
//#endregion
//#region src/api/parsers/markdown/parseMarkdown.ts
function hn(e, t) {
	let n = t.value ? t.value : "", r = {};
	t.lang && (r["data-language"] = t.lang);
	let i = {
		type: "element",
		tagName: "code",
		properties: r,
		children: [{
			type: "text",
			value: n
		}]
	};
	return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = {
		type: "element",
		tagName: "pre",
		properties: {},
		children: [i]
	}, e.patch(t, i), i;
}
function gn(e, t) {
	let n = String(t?.url || ""), r = {
		type: "element",
		tagName: "video",
		properties: {
			src: n,
			"data-name": t?.title ? String(t.title) : void 0,
			"data-url": n,
			controls: !0
		},
		children: []
	};
	return e.patch?.(t, r), r = e.applyData ? e.applyData(t, r) : r, r;
}
function q(e) {
	return lt().use(ut).use(ct).use(dt, { handlers: {
		...ft,
		image: (e, t) => s(String(t?.url || "")) ? gn(e, t) : ft.image(e, t),
		code: hn,
		blockquote: (e, t) => {
			let n = {
				type: "element",
				tagName: "blockquote",
				properties: {},
				children: e.wrap(e.all(t), !1)
			};
			return e.patch(t, n), e.applyData(t, n);
		}
	} }).use(pt).processSync(e).value;
}
function _n(e, t) {
	return K(q(e), t);
}
//#endregion
//#region src/editor/managers/ExportManager.ts
var vn = class {
	constructor(e) {
		this.editor = e;
	}
	blocksToHTMLLossy(e = this.editor.document) {
		return Ce(this.editor.pmSchema, this.editor).exportBlocks(e, {});
	}
	blocksToFullHTML(e = this.editor.document) {
		return It(this.editor.pmSchema, this.editor).serializeBlocks(e, {});
	}
	tryParseHTMLToBlocks(e) {
		return K(e, this.editor.pmSchema);
	}
	blocksToMarkdownLossy(e = this.editor.document) {
		return Ae(e, this.editor.pmSchema, this.editor, {});
	}
	tryParseMarkdownToBlocks(e) {
		return _n(e, this.editor.pmSchema);
	}
	pasteHTML(e, t = !1) {
		let n = e;
		if (!t) {
			let t = this.tryParseHTMLToBlocks(e);
			n = this.blocksToFullHTML(t);
		}
		n && this.editor.prosemirrorView?.pasteHTML(n);
	}
	pasteText(e) {
		return this.editor.prosemirrorView?.pasteText(e);
	}
	pasteMarkdown(e) {
		let t = q(e);
		return this.pasteHTML(t);
	}
}, yn = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/linkDetector.ts
function bn(e) {
	let t = [], n = [], r = 0;
	for (; r < e.length;) {
		let i = 0;
		for (; r + i < e.length && e.charCodeAt(r + i) >= 48 && e.charCodeAt(r + i) <= 57;) i++;
		if (i > 0) {
			t.push(n.join(""));
			let a = parseInt(e.substring(r, r + i), 10);
			for (; a-- > 0;) n.pop();
			r += i;
		} else n.push(e[r]), r++;
	}
	return t;
}
var xn = new Set(bn(yn)), Sn = new Set(["localhost"]), Cn = /[.,;:!?"']+$/, wn = /(?:https?|ftp|ftps):\/\/[^\s]+/g, Tn = /mailto:[^\s]+/g, En = /[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}/g, Dn = /(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:[/?#][^\s]*)?/g;
function On(e) {
	let t = e, n = !0;
	for (; n;) {
		n = !1;
		let e = t;
		t = t.replace(Cn, ""), t !== e && (n = !0);
		for (let [e, r] of [["(", ")"], ["[", "]"]]) for (; t.endsWith(r);) {
			let i = kn(t, e);
			if (kn(t, r) > i) t = t.slice(0, -1), n = !0;
			else break;
		}
	}
	return t;
}
function kn(e, t) {
	let n = 0;
	for (let r = 0; r < e.length; r++) e[r] === t && n++;
	return n;
}
function An(e) {
	let t = e.split(".");
	return t[t.length - 1].toLowerCase();
}
function jn(e) {
	let t = An(e);
	return xn.has(t);
}
function Mn(e, t, n) {
	return t === "email" ? "mailto:" + e : /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(e) || /^mailto:/i.test(e) ? e : n + "://" + e;
}
function Nn(e, t) {
	if (!e) return [];
	let n = t?.defaultProtocol || "http", r = [];
	for (let t of e.matchAll(wn)) r.push({
		type: "url",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	for (let t of e.matchAll(Tn)) r.push({
		type: "url",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	for (let t of e.matchAll(En)) r.push({
		type: "email",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	for (let t of e.matchAll(Dn)) r.push({
		type: "url",
		value: t[0],
		start: t.index,
		end: t.index + t[0].length
	});
	r.sort((e, t) => e.start - t.start || t.end - e.end);
	let i = [], a = -1;
	for (let e of r) e.start >= a && (i.push(e), a = e.end);
	let o = [];
	for (let e of i) {
		let t = On(e.value);
		if (!t) continue;
		let r = e.start, i = r + t.length;
		if (e.type === "url" && !/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(t)) {
			let e = new URL("http://" + t).hostname;
			if (!jn(e)) continue;
		}
		if (e.type === "email") {
			let e = t.split("@")[1];
			if (!jn(e)) continue;
		}
		let a = Mn(t, e.type, n);
		o.push({
			type: e.type,
			value: t,
			isLink: !0,
			href: a,
			start: r,
			end: i
		});
	}
	return o;
}
function Pn(e, t = "http") {
	if (!e) return [X(e, 0, 0)];
	for (let [n, r] of [
		["(", ")"],
		["[", "]"],
		["{", "}"]
	]) if (e.startsWith(n) && e.endsWith(r) && e.length > 2) {
		let i = e.slice(1, -1);
		if (J(i)) return [
			X(n, 0, 1),
			Y(i, 1, 1 + i.length, t),
			X(r, 1 + i.length, e.length)
		];
	}
	if (e.endsWith(".") && e.length > 1) {
		let n = e.slice(0, -1);
		if (J(n)) return [Y(n, 0, n.length, t), X(".", n.length, e.length)];
	}
	return J(e) ? [Y(e, 0, e.length, t)] : [X(e, 0, e.length)];
}
function J(e) {
	if (/^(?:https?|ftp|ftps):\/\/[^\s]+$/.test(e) || /^mailto:[^\s]+$/.test(e) || Sn.has(e.toLowerCase())) return !0;
	let t = e.match(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+([a-zA-Z]{2,})(?::\d{1,5})?(?:[/?#][^\s]*)?$/);
	if (t) {
		let e = t[1].toLowerCase();
		if (xn.has(e)) return !0;
	}
	return !1;
}
function Y(e, t, n, r) {
	let i = e.includes("@") && !e.includes("://") && !e.startsWith("mailto:") ? "email" : "url";
	return {
		type: i,
		value: e,
		isLink: !0,
		href: Mn(e, i, r),
		start: t,
		end: n
	};
}
function X(e, t, n) {
	return {
		type: "text",
		value: e,
		isLink: !1,
		href: e,
		start: t,
		end: n
	};
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/whitespace.ts
var Z = "[\0- \xA0 ᠎ -\u2029 　]", Fn = new RegExp(Z), In = RegExp(`${Z}$`), Ln = new RegExp(Z, "g");
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/autolink.ts
function Rn(e) {
	return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function zn(e) {
	return new ot({
		key: new st("autolink"),
		appendTransaction: (t, n, r) => {
			let i = t.some((e) => e.docChanged) && !n.doc.eq(r.doc), a = t.some((e) => e.getMeta("preventAutolink"));
			if (!i || a) return;
			let { tr: o } = r;
			if (Xe(Ge(n.doc, [...t])).forEach(({ newRange: t }) => {
				let n = qe(r.doc, t, (e) => e.isTextblock), i, a;
				if (n.length > 1) i = n[0], a = r.doc.textBetween(i.pos, i.pos + i.node.nodeSize, void 0, " ");
				else if (n.length) {
					let e = r.doc.textBetween(t.from, t.to, " ", " ");
					if (!In.test(e)) return;
					i = n[0], a = r.doc.textBetween(i.pos, t.to, void 0, " ");
				}
				if (i && a) {
					let t = a.split(Fn).filter(Boolean);
					if (t.length <= 0) return;
					let n = t[t.length - 1], s = i.pos + a.lastIndexOf(n);
					if (!n) return;
					let c = Pn(n, e.defaultProtocol);
					if (!Rn(c)) return;
					c.filter((e) => e.isLink).map((e) => ({
						...e,
						from: s + e.start + 1,
						to: s + e.end + 1
					})).filter((e) => r.schema.marks.code ? !r.doc.rangeHasMark(e.from, e.to, r.schema.marks.code) : !0).filter((t) => e.validate(t.value)).filter((t) => e.shouldAutoLink(t.value)).forEach((t) => {
						Qe(t.from, t.to, r.doc).some((t) => t.mark.type === e.type) || o.addMark(t.from, t.to, e.type.create({ href: t.href }));
					});
				}
			}), o.steps.length) return o;
		}
	});
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/clickHandler.ts
function Bn(e) {
	return new ot({
		key: new st("handleClickLink"),
		props: { handleClick: (t, n, r) => {
			if (r.button !== 0 || !t.editable) return !1;
			let i = null;
			if (r.target instanceof HTMLAnchorElement && r.target.getAttribute("data-inline-content-type") === "link") i = r.target;
			else {
				let t = r.target;
				if (!t) return !1;
				let n = e.tiptapEditor.view.dom;
				i = t.closest("a[data-inline-content-type=\"link\"]"), i && !n.contains(i) && (i = null);
			}
			if (!i) return !1;
			if (e.onClick) {
				if (!e.editor) throw Error("BlockNoteEditor not found in Link click handler");
				return e.onClick(r, e.editor) ?? !0;
			}
			let a = Ye(t.state, e.type.name), o = i.href ?? a.href, s = i.target ?? a.target;
			return o ? (window.open(o, s), !0) : !1;
		} }
	});
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/helpers/pasteHandler.ts
function Vn(e) {
	return new ot({
		key: new st("handlePasteLink"),
		props: { handlePaste: (t, n, r) => {
			let { shouldAutoLink: i, isValidLink: a } = e, { state: o } = t, { selection: s } = o, { empty: c } = s;
			if (c) return !1;
			let l = "";
			r.content.forEach((e) => {
				l += e.textContent;
			});
			let u = Nn(l, { defaultProtocol: e.defaultProtocol }).find((e) => e.isLink && e.value === l);
			return !l || !u || !a(u.value) || i !== void 0 && !i(u.value) ? !1 : e.editor.commands.setMark(e.type, { href: u.href });
		} }
	});
}
//#endregion
//#region src/extensions/tiptap-extensions/Link/link.ts
var Hn = "https", Un = /^(?:(?:http|https|ftp|ftps|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))/i;
function Wn(e) {
	if (!e) return !0;
	let t = e.replace(Ln, "");
	return Un.test(t);
}
function Gn(e) {
	let t = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), n = /^[a-z][a-z0-9+.-]*:/i.test(e);
	if (t || n && !e.includes("@")) return !0;
	let r = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
	return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(r) || !/\./.test(r));
}
var Kn = k.create({
	name: "link",
	priority: 1e3,
	keepOnSplit: !1,
	exitable: !0,
	inclusive: !1,
	addOptions() {
		return {
			HTMLAttributes: {
				target: "_blank",
				rel: "noopener noreferrer nofollow",
				className: "bn-inline-content-section",
				"data-inline-content-type": "link"
			},
			editor: void 0,
			onClick: void 0,
			isValidLink: Wn
		};
	},
	addAttributes() {
		return { href: {
			default: null,
			parseHTML(e) {
				return e.getAttribute("href");
			}
		} };
	},
	parseHTML() {
		let e = this.options.isValidLink;
		return [{
			tag: "a[href]",
			getAttrs: (t) => {
				let n = t.getAttribute("href");
				return !n || !e(n) ? !1 : null;
			}
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return this.options.isValidLink(e.href) ? [
			"a",
			M(e, this.options.HTMLAttributes),
			0
		] : [
			"a",
			M({
				...e,
				href: ""
			}, this.options.HTMLAttributes),
			0
		];
	},
	addPasteRules() {
		let e = this.options.isValidLink;
		return [tt({
			find: (t) => {
				let n = [];
				if (t) {
					let r = Nn(t, { defaultProtocol: Hn }).filter((t) => t.isLink && e(t.value));
					for (let e of r) Gn(e.value) && n.push({
						text: e.value,
						data: { href: e.href },
						index: e.start
					});
				}
				return n;
			},
			type: this.type,
			getAttributes: (e) => ({ href: e.data?.href })
		})];
	},
	addProseMirrorPlugins() {
		let e = [];
		return e.push(zn({
			type: this.type,
			defaultProtocol: Hn,
			validate: this.options.isValidLink,
			shouldAutoLink: Gn
		})), e.push(Bn({
			type: this.type,
			tiptapEditor: this.editor,
			editor: this.options.editor,
			onClick: this.options.onClick
		})), e.push(Vn({
			editor: this.editor,
			defaultProtocol: Hn,
			type: this.type,
			shouldAutoLink: Gn,
			isValidLink: this.options.isValidLink
		})), e;
	}
}), qn = [
	"vscode-editor-data",
	"blocknote/html",
	"text/markdown",
	"text/html",
	"text/plain",
	"Files"
];
//#endregion
//#region src/api/clipboard/fromClipboard/handleFileInsertion.ts
function Jn(e, t) {
	if (!e.startsWith(".") || !t.startsWith(".")) throw Error("The strings provided are not valid file extensions.");
	return e === t;
}
function Yn(e, t) {
	let n = e.split("/"), r = t.split("/");
	if (n.length !== 2) throw Error(`The string ${e} is not a valid MIME type.`);
	if (r.length !== 2) throw Error(`The string ${t} is not a valid MIME type.`);
	return n[1] === "*" || r[1] === "*" ? n[0] === r[0] : (n[0] === "*" || r[0] === "*" || n[0] === r[0]) && n[1] === r[1];
}
function Xn(e, t, n, r = "after") {
	let i;
	return i = Array.isArray(t.content) && t.content.length === 0 ? e.updateBlock(t, n).id : e.insertBlocks([n], t, r)[0].id, i;
}
async function Zn(e, t) {
	if (!t.uploadFile) {
		console.warn("Attempted ot insert file, but uploadFile is not set in the BlockNote editor options");
		return;
	}
	let n = "dataTransfer" in e ? e.dataTransfer : e.clipboardData;
	if (n === null) return;
	let r = null;
	for (let e of qn) if (n.types.includes(e)) {
		r = e;
		break;
	}
	if (r !== "Files") return;
	let i = n.items;
	if (i) {
		e.preventDefault();
		for (let n = 0; n < i.length; n++) {
			let r = "file";
			for (let e of Object.values(t.schema.blockSpecs)) for (let t of e.implementation.meta?.fileBlockAccept || []) {
				let a = t.startsWith("."), o = i[n].getAsFile();
				if (o && (!a && o.type && Yn(i[n].type, t) || a && Jn("." + o.name.split(".").pop(), t))) {
					r = e.config.type;
					break;
				}
			}
			let a = i[n].getAsFile();
			if (a) {
				let n = {
					type: r,
					props: { name: a.name }
				}, i;
				if (e.type === "paste") {
					let e = t.getTextCursorPosition().block;
					i = Xn(t, e, n);
				} else if (e.type === "drop") {
					let r = {
						left: e.clientX,
						top: e.clientY
					}, a = t.prosemirrorView.posAtCoords(r);
					if (!a) return;
					i = t.transact((e) => {
						let i = g(e.doc, a.pos), o = (t.domElement?.querySelector(`[data-id="${i.node.attrs.id}"]`))?.getBoundingClientRect();
						return Xn(t, t.getBlock(i.node.attrs.id), n, o && (o.top + o.bottom) / 2 > r.top ? "before" : "after");
					});
				} else return;
				let o = await t.uploadFile(a, i), s = typeof o == "string" ? { props: { url: o } } : { ...o };
				t.updateBlock(i, s);
			}
		}
	}
}
//#endregion
//#region src/api/clipboard/fromClipboard/fileDropExtension.ts
var Qn = (e) => O.create({
	name: "dropFile",
	addProseMirrorPlugins() {
		return [new P({ props: { handleDOMEvents: { drop(t, n) {
			if (!e.isEditable) return;
			let r = null;
			for (let e of qn) if (n.dataTransfer.types.includes(e)) {
				r = e;
				break;
			}
			return r === null ? !0 : r === "Files" ? (Zn(n, e), !0) : !1;
		} } } })];
	}
}), $n = /(^|\n) {0,3}#{1,6} {1,8}[^\n]{1,64}\r?\n\r?\n\s{0,32}\S/, er = /(_|__|\*|\*\*|~~|==|\+\+)(?!\s)(?:[^\s](?:.{0,62}[^\s])?|\S)(?=\1)/, tr = /\[[^\]]{1,128}\]\(https?:\/\/\S{1,999}\)/, nr = /(?:\s|^)`(?!\s)(?:[^\s`](?:[^`]{0,46}[^\s`])?|[^\s`])`([^\w]|$)/, rr = /(?:^|\n)\s{0,5}-\s{1}[^\n]+\n\s{0,15}-\s/, ir = /(?:^|\n)\s{0,5}\d+\.\s{1}[^\n]+\n\s{0,15}\d+\.\s/, ar = /\n{2} {0,3}-{2,48}\n{2}/, or = /(?:\n|^)(```|~~~|\$\$)(?!`|~)[^\s]{0,64} {0,64}[^\n]{0,64}\n[\s\S]{0,9999}?\s*\1 {0,64}(?:\n+|$)/, sr = /(?:\n|^)(?!\s)\w[^\n]{0,64}\r?\n(-|=)\1{0,64}\n\n\s{0,64}(\w|$)/, cr = /(?:^|(\r?\n\r?\n))( {0,3}>[^\n]{1,333}\n){1,999}($|(\r?\n))/, lr = /^\s*\|(.+\|)+\s*$/m, ur = /^\s*\|(\s*[-:]+[-:]\s*\|)+\s*$/m, dr = /^\s*\|(.+\|)+\s*$/m, fr = (e) => $n.test(e) || er.test(e) || tr.test(e) || nr.test(e) || rr.test(e) || ir.test(e) || ar.test(e) || or.test(e) || sr.test(e) || cr.test(e) || lr.test(e) || ur.test(e) || dr.test(e);
//#endregion
//#region src/api/clipboard/fromClipboard/handleVSCodePaste.ts
async function pr(e, t) {
	let { schema: n } = t.state;
	if (!e.clipboardData) return !1;
	let r = e.clipboardData.getData("text/plain");
	if (!r) return !1;
	if (!n.nodes.codeBlock) return t.pasteText(r), !0;
	let i = e.clipboardData.getData("vscode-editor-data"), a = (i ? JSON.parse(i) : void 0)?.mode;
	return a ? (t.pasteHTML(`<pre><code class="language-${a}">${r.replace(/\r\n?/g, "\n")}</code></pre>`), !0) : !1;
}
//#endregion
//#region src/api/clipboard/fromClipboard/pasteExtension.ts
function mr({ event: e, editor: t, prioritizeMarkdownOverHTML: n, plainTextAsMarkdown: r }) {
	if (t.transact((e) => e.selection.$from.parent.type.spec.code && e.selection.$to.parent.type.spec.code)) {
		let n = e.clipboardData?.getData("text/plain");
		if (n) return t.pasteText(n), !0;
	}
	let i;
	for (let t of qn) if (e.clipboardData.types.includes(t)) {
		i = t;
		break;
	}
	if (!i) return !0;
	if (i === "vscode-editor-data") return pr(e, t.prosemirrorView), !0;
	if (i === "Files") return Zn(e, t), !0;
	let a = e.clipboardData.getData(i);
	if (i === "blocknote/html") return t.pasteHTML(a, !0), !0;
	if (i === "text/markdown") return t.pasteMarkdown(a), !0;
	if (n) {
		let n = e.clipboardData.getData("text/plain");
		if (fr(n)) return t.pasteMarkdown(n), !0;
	}
	return i === "text/html" ? (t.pasteHTML(a), !0) : r ? (t.pasteMarkdown(a), !0) : (t.pasteText(a), !0);
}
var hr = (e, t) => O.create({
	name: "pasteFromClipboard",
	addProseMirrorPlugins() {
		return [new P({ props: { handleDOMEvents: { paste(n, r) {
			if (r.preventDefault(), e.isEditable) return t({
				event: r,
				editor: e,
				defaultPasteHandler: ({ prioritizeMarkdownOverHTML: t = !0, plainTextAsMarkdown: n = !0 } = {}) => mr({
					event: r,
					editor: e,
					prioritizeMarkdownOverHTML: t,
					plainTextAsMarkdown: n
				})
			});
		} } } })];
	}
});
//#endregion
//#region src/api/clipboard/toClipboard/copyExtension.ts
function gr(e, t, n) {
	let r = !1, i = e.state.selection instanceof it;
	if (!i) {
		let n = e.state.doc.slice(e.state.selection.from, e.state.selection.to, !1).content, i = [];
		for (let e = 0; e < n.childCount; e++) i.push(n.child(e));
		r = i.find((e) => e.type.isInGroup("bnBlock") || e.type.name === "blockGroup" || e.type.spec.group === "blockContent") === void 0, r && (t = n);
	}
	let a, o = Ce(e.state.schema, n);
	if (i) {
		t.firstChild?.type.name === "table" && (t = t.firstChild.content);
		let e = re(t, n.schema.inlineContentSchema, n.schema.styleSchema);
		a = `<table>${o.exportInlineContent(e, {}, "table")}</table>`;
	} else if (r) {
		let e = oe(t, n.schema.inlineContentSchema, n.schema.styleSchema);
		a = o.exportInlineContent(e, {});
	} else {
		let e = we(t);
		a = o.exportBlocks(e, {});
	}
	return a;
}
function _r(e, t) {
	"node" in e.state.selection && e.state.selection.node.type.spec.group === "blockContent" && t.transact((t) => t.setSelection(new N(t.doc.resolve(e.state.selection.from - 1))));
	let n = e.serializeForClipboard(e.state.selection.content()).dom.innerHTML, r = e.state.selection.content().content, i = gr(e, r, t);
	return {
		clipboardHTML: n,
		externalHTML: i,
		markdown: xe(i)
	};
}
var vr = (e) => {
	if (e.state.selection.empty) return !0;
	let t = window.getSelection();
	if (t && !t.isCollapsed) {
		let e = t.focusNode;
		for (; e;) {
			if (e instanceof HTMLElement && e.getAttribute("contenteditable") === "false") return !0;
			e = e.parentElement;
		}
	}
	return !1;
}, yr = (e, t, n) => {
	n.preventDefault(), n.clipboardData.clearData();
	let { clipboardHTML: r, externalHTML: i, markdown: a } = _r(t, e);
	n.clipboardData.setData("blocknote/html", r), n.clipboardData.setData("text/html", i), n.clipboardData.setData("text/plain", a);
}, br = (e) => O.create({
	name: "copyToClipboard",
	addProseMirrorPlugins() {
		return [new P({ props: { handleDOMEvents: {
			copy(t, n) {
				return vr(t) || yr(e, t, n), !0;
			},
			cut(t, n) {
				return vr(t) ? !0 : (yr(e, t, n), t.editable && t.dispatch(t.state.tr.deleteSelection()), !0);
			},
			dragstart(t, n) {
				if (!("node" in t.state.selection) || t.state.selection.node.type.spec.group !== "blockContent") return;
				e.transact((e) => e.setSelection(new N(e.doc.resolve(t.state.selection.from - 1)))), n.preventDefault(), n.dataTransfer.clearData();
				let { clipboardHTML: r, externalHTML: i, markdown: a } = _r(t, e);
				return n.dataTransfer.setData("blocknote/html", r), n.dataTransfer.setData("text/html", i), n.dataTransfer.setData("text/plain", a), !0;
			}
		} } })];
	}
}), xr = O.create({
	name: "blockBackgroundColor",
	addGlobalAttributes() {
		return [{
			types: ["tableCell", "tableHeader"],
			attributes: { backgroundColor: m() }
		}];
	}
}), Sr = A.create({
	name: "hardBreak",
	inline: !0,
	group: "inline",
	selectable: !1,
	linebreakReplacement: !0,
	priority: 10,
	parseHTML() {
		return [{ tag: "br" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["br", M(this.options.HTMLAttributes, e)];
	},
	renderText() {
		return "\n";
	}
}), Cr = (e, t) => {
	let n = e.resolve(t), r = n.depth - 1;
	if (r < 1) return;
	let i = n.before(r), a = e.resolve(i).nodeAfter;
	if (a) return a.type.spec.group?.includes("bnBlock") ? _(e.resolve(i)) : Cr(e, i);
}, Q = (e, t) => {
	let n = e.resolve(t), r = n.index();
	if (r === 0) return;
	let i = n.posAtIndex(r - 1);
	return _(e.resolve(i));
}, $ = (e, t) => {
	let n = e.resolve(t), r = n.index();
	if (r === n.node().childCount - 1) return;
	let i = n.posAtIndex(r + 1);
	return _(e.resolve(i));
}, wr = (e, t) => {
	for (; t.childContainer;) {
		let n = t.childContainer.node, r = e.resolve(t.childContainer.beforePos + 1).posAtIndex(n.childCount - 1);
		t = _(e.resolve(r));
	}
	return t;
}, Tr = (e, t) => e.isBlockContainer && e.blockContent.node.type.spec.content === "inline*" && e.blockContent.node.childCount > 0 && t.isBlockContainer && t.blockContent.node.type.spec.content === "inline*", Er = (e, t, n, r) => {
	if (!r.isBlockContainer) throw Error(`Attempted to merge block at position ${r.bnBlock.beforePos} into previous block at position ${n.bnBlock.beforePos}, but next block is not a block container`);
	if (r.childContainer) {
		let n = e.doc.resolve(r.childContainer.beforePos + 1), i = e.doc.resolve(r.childContainer.afterPos - 1), a = n.blockRange(i);
		if (t) {
			let t = e.doc.resolve(r.bnBlock.beforePos);
			e.tr.lift(a, t.depth);
		}
	}
	if (t) {
		if (!n.isBlockContainer) throw Error(`Attempted to merge block at position ${r.bnBlock.beforePos} into previous block at position ${n.bnBlock.beforePos}, but previous block is not a block container`);
		t(e.tr.delete(n.blockContent.afterPos - 1, r.blockContent.beforePos + 1));
	}
	return !0;
}, Dr = (e) => ({ state: t, dispatch: n }) => {
	let r = _(t.doc.resolve(e)), i = Q(t.doc, r.bnBlock.beforePos);
	if (!i) return !1;
	let a = wr(t.doc, i);
	return Tr(a, r) ? Er(t, n, a, r) : !1;
}, Or = O.create({
	priority: 50,
	addKeyboardShortcuts() {
		let e = () => this.editor.commands.first(({ chain: e, commands: t }) => [
			() => t.deleteSelection(),
			() => t.undoInputRule(),
			() => t.command(({ state: e }) => {
				let n = p(e);
				if (!n.isBlockContainer) return !1;
				let r = e.selection.from === n.blockContent.beforePos + 1, i = n.blockContent.node.type.name === "paragraph";
				return r && !i ? t.command(u(n.bnBlock.beforePos, {
					type: "paragraph",
					props: {}
				})) : !1;
			}),
			() => t.command(({ state: e, tr: t }) => {
				let n = p(e);
				if (!n.isBlockContainer) return !1;
				let { blockContent: r } = n;
				return e.selection.from === r.beforePos + 1 ? G(t, t.doc.type.schema.nodes.blockContainer, t.doc.type.schema.nodes.blockGroup) : !1;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				let { bnBlock: r, blockContent: i } = n, a = Q(t.doc, n.bnBlock.beforePos);
				if (!a || !a.isBlockContainer || a.blockContent.node.type.spec.content !== "inline*") return !1;
				let o = t.selection.from === i.beforePos + 1, s = t.selection.empty, c = r.beforePos;
				return o && s ? e().command(Dr(c)).scrollIntoView().run() : !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = p(e);
				if (!r.isBlockContainer || e.selection.from !== r.blockContent.beforePos + 1) return !1;
				let i = Q(e.doc, r.bnBlock.beforePos);
				if (!i || i.isBlockContainer) return !1;
				if (n) {
					let e = i.bnBlock.afterPos - 1, n = t.doc.resolve(e - 1);
					return t.delete(r.bnBlock.beforePos, r.bnBlock.afterPos), t.insert(n.pos, r.bnBlock.node), t.setSelection(F.near(t.doc.resolve(n.pos + 1))), !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = p(e);
				if (!r.isBlockContainer || t.selection.from !== r.blockContent.beforePos + 1) return !1;
				let i = t.doc.resolve(r.bnBlock.beforePos);
				if (i.nodeBefore || i.node().type.name !== "column") return !1;
				let a = t.doc.resolve(r.bnBlock.beforePos), o = t.doc.resolve(a.before()), s = o.before();
				return n && (t.delete(r.bnBlock.beforePos, r.bnBlock.afterPos), H(t, s), o.pos === s + 1 ? (t.insert(s, r.bnBlock.node), t.setSelection(F.near(t.doc.resolve(s)))) : (t.insert(o.pos - 1, r.bnBlock.node), t.setSelection(F.near(t.doc.resolve(o.pos))))), !0;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				if (n.blockContent.node.childCount === 0 && n.blockContent.node.type.spec.content === "inline*") {
					let r = Q(t.doc, n.bnBlock.beforePos);
					if (!r) return !1;
					let i = wr(t.doc, r);
					if (!i.isBlockContainer || !i || !i.isBlockContainer) return !1;
					let a = e();
					if (n.childContainer && a.insertContentAt(n.bnBlock.afterPos, n.childContainer?.node.content), i.blockContent.node.type.spec.content === "tableRow+") {
						let e = n.bnBlock.beforePos - 1 - 1 - 1 - 1 - 1;
						a = a.setTextSelection(e);
					} else if (i.blockContent.node.type.spec.content === "") a = a.setNodeSelection(i.blockContent.beforePos);
					else {
						let e = i.blockContent.afterPos - 1;
						a = a.setTextSelection(e);
					}
					return a.deleteRange({
						from: n.bnBlock.beforePos,
						to: n.bnBlock.afterPos
					}).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				let r = t.selection.from === n.blockContent.beforePos + 1, i = t.selection.empty, a = Q(t.doc, n.bnBlock.beforePos);
				if (a && r && i) {
					let r = wr(t.doc, a);
					if (!r.isBlockContainer) return !1;
					if (r.blockContent.node.type.spec.content === "" || r.blockContent.node.type.spec.content === "inline*" && r.blockContent.node.childCount === 0) return e().cut({
						from: n.bnBlock.beforePos,
						to: n.bnBlock.afterPos
					}, r.bnBlock.afterPos).deleteRange({
						from: r.bnBlock.beforePos,
						to: r.bnBlock.afterPos
					}).run();
				}
				return !1;
			})
		]), t = () => this.editor.commands.first(({ chain: e, commands: t }) => [
			() => t.deleteSelection(),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer || !n.childContainer) return !1;
				let { blockContent: r, childContainer: i } = n, a = t.selection.from === r.afterPos - 1, o = t.selection.empty, s = _(t.doc.resolve(i.beforePos + 1));
				if (!s.isBlockContainer) return !1;
				if (a && o) {
					let n = s.blockContent.node, a = n.type.spec.content === "inline*", o = r.node.type.spec.content === "inline*";
					return e().insertContentAt(s.bnBlock.afterPos, s.childContainer?.node.content || T.empty).deleteRange(i.node.childCount === 1 ? {
						from: i.beforePos,
						to: i.afterPos
					} : {
						from: s.bnBlock.beforePos,
						to: s.bnBlock.afterPos
					}).insertContentAt(t.selection.from, a && o ? n.content : null).setTextSelection(t.selection.from).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				let { bnBlock: r, blockContent: i } = n, a = $(t.doc, n.bnBlock.beforePos);
				if (!a || !a.isBlockContainer) return !1;
				let o = t.selection.from === i.afterPos - 1, s = t.selection.empty, c = r.afterPos;
				return o && s ? e().command(Dr(c)).scrollIntoView().run() : !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = p(e);
				if (!r.isBlockContainer || e.selection.from !== r.blockContent.afterPos - 1) return !1;
				let i = $(e.doc, r.bnBlock.beforePos);
				if (!i || i.isBlockContainer) return !1;
				if (n) {
					let e = i.bnBlock.beforePos + 1, n = t.doc.resolve(e + 1);
					return t.delete(n.pos, n.pos + n.nodeAfter.nodeSize), H(t, i.bnBlock.beforePos), t.insert(r.bnBlock.afterPos, n.nodeAfter), t.setSelection(F.near(t.doc.resolve(n.pos))), !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, tr: t, dispatch: n }) => {
				let r = p(e);
				if (!r.isBlockContainer || t.selection.from !== r.blockContent.afterPos - 1) return !1;
				let i = t.doc.resolve(r.bnBlock.afterPos);
				if (i.nodeAfter || i.node().type.name !== "column") return !1;
				let a = t.doc.resolve(r.bnBlock.afterPos), o = t.doc.resolve(a.after()), s = o.after();
				if (n) {
					let e = o.pos === s - 1 ? s : o.pos + 1, n = _(t.doc.resolve(e));
					t.delete(n.bnBlock.beforePos, n.bnBlock.afterPos), H(t, s - o.node().nodeSize), t.insert(a.pos, n.bnBlock.node), t.setSelection(F.near(t.doc.resolve(e)));
				}
				return !0;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				let { blockContent: r } = n, i = t.selection.from === r.afterPos - 1, a = t.selection.empty;
				if (i && a) {
					let i = (e, t) => {
						let n = $(e, t);
						if (n) return n;
						let r = Cr(e, t);
						if (r) return i(e, r.bnBlock.beforePos);
					}, a = i(t.doc, n.bnBlock.beforePos);
					if (!a || !a.isBlockContainer) return !1;
					let o = a.blockContent.node, s = o.type.spec.content === "inline*", c = r.node.type.spec.content === "inline*";
					return e().insertContentAt(a.bnBlock.afterPos, a.childContainer?.node.content || T.empty).deleteRange({
						from: a.bnBlock.beforePos,
						to: a.bnBlock.afterPos
					}).insertContentAt(t.selection.from, s && c ? o.content : null).setTextSelection(t.selection.from).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				if (n.blockContent.node.childCount === 0 && n.blockContent.node.type.spec.content === "inline*") {
					let r = $(t.doc, n.bnBlock.beforePos);
					if (!r || !r.isBlockContainer) return !1;
					let i = e();
					if (r.blockContent.node.type.spec.content === "tableRow+") {
						let e = n.bnBlock.afterPos + 1 + 1 + 1 + 1 + 1;
						i = i.setTextSelection(e);
					} else i = r.blockContent.node.type.spec.content === "" ? i.setNodeSelection(r.blockContent.beforePos) : i.setTextSelection(r.blockContent.beforePos + 1);
					return i.deleteRange({
						from: n.bnBlock.beforePos,
						to: n.bnBlock.afterPos
					}).scrollIntoView().run();
				}
				return !1;
			}),
			() => t.command(({ state: t }) => {
				let n = p(t);
				if (!n.isBlockContainer) return !1;
				let r = t.selection.from === n.blockContent.afterPos - 1, i = t.selection.empty, a = $(t.doc, n.bnBlock.beforePos);
				if (!a || !a.isBlockContainer) return !1;
				if (a && r && i && (a.blockContent.node.type.spec.content === "" || a.blockContent.node.type.spec.content === "inline*" && a.blockContent.node.childCount === 0)) {
					let t = a.bnBlock.node.lastChild.content;
					return e().deleteRange({
						from: a.bnBlock.beforePos,
						to: a.bnBlock.afterPos
					}).insertContentAt(n.bnBlock.afterPos, a.bnBlock.node.childCount === 2 ? t : null).run();
				}
				return !1;
			})
		]), n = (e = !1) => this.editor.commands.first(({ commands: t, tr: n }) => [
			() => t.command(({ state: e, tr: t }) => {
				let n = p(e);
				if (!n.isBlockContainer) return !1;
				let { bnBlock: r, blockContent: i } = n, { depth: a } = e.doc.resolve(r.beforePos), o = e.selection.$anchor.parentOffset === 0, s = e.selection.anchor === e.selection.head, c = i.node.childCount === 0;
				return o && s && c && a > 1 ? G(t, t.doc.type.schema.nodes.blockContainer, t.doc.type.schema.nodes.blockGroup) : !1;
			}),
			() => t.command(({ state: t }) => {
				let r = p(t), i = this.options.editor.schema.blockSchema[r.blockNoteType].meta?.hardBreakShortcut ?? "shift+enter";
				if (i === "none") return !1;
				if (i === "shift+enter" && e || i === "enter") {
					let e = n.storedMarks || n.selection.$head.marks().filter((e) => this.editor.extensionManager.splittableMarks.includes(e.type.name));
					return n.insert(n.selection.head, n.doc.type.schema.nodes.hardBreak.create()).ensureMarks(e), !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, dispatch: t, tr: n }) => {
				let r = p(e);
				if (!r.isBlockContainer) return !1;
				let { bnBlock: i, blockContent: a } = r, o = e.selection.$anchor.parentOffset === 0, s = e.selection.anchor === e.selection.head, c = a.node.childCount === 0;
				if (o && s && c) {
					let a = i.afterPos, o = a + 2;
					if (t) {
						let t = e.schema.nodes.blockContainer.createAndFill(void 0, [e.schema.nodes.paragraph.createAndFill() || void 0, r.childContainer?.node].filter((e) => e !== void 0));
						n.insert(a, t).setSelection(new F(n.doc.resolve(o))).scrollIntoView(), r.childContainer && n.delete(r.childContainer.beforePos, r.childContainer.afterPos);
					}
					return !0;
				}
				return !1;
			}),
			() => t.command(({ state: e, chain: t }) => {
				let n = p(e);
				if (!n.isBlockContainer) return !1;
				let { blockContent: r } = n, i = e.selection.$anchor.parentOffset === 0;
				return r.node.childCount === 0 ? !1 : (t().deleteSelection().command(o(e.selection.from, i, i)).run(), !0);
			})
		]);
		return {
			Backspace: e,
			Delete: t,
			Enter: () => n(),
			"Shift-Enter": () => n(!0),
			Tab: () => this.options.tabBehavior !== "prefer-indent" && (this.options.editor.getExtension(w)?.store.state || this.options.editor.getExtension(y)?.store.state !== void 0) ? !1 : Kt(this.options.editor),
			"Shift-Tab": () => this.options.tabBehavior !== "prefer-indent" && (this.options.editor.getExtension(w)?.store.state || this.options.editor.getExtension(y)?.store.state !== void 0) ? !1 : Jt(this.options.editor),
			"Shift-Mod-ArrowUp": () => (this.options.editor.moveBlocksUp(), !0),
			"Shift-Mod-ArrowDown": () => (this.options.editor.moveBlocksDown(), !0),
			"Mod-z": () => this.options.editor.undo(),
			"Mod-y": () => this.options.editor.redo(),
			"Shift-Mod-z": () => this.options.editor.redo()
		};
	}
}), kr = k.create({
	name: "insertion",
	inclusive: !1,
	excludes: "deletion modification insertion",
	addAttributes() {
		return { id: {
			default: null,
			validate: "number"
		} };
	},
	extendMarkSchema(e) {
		return e.name === "insertion" ? {
			blocknoteIgnore: !0,
			inclusive: !1,
			toDOM(e, t) {
				return [
					"ins",
					{
						"data-id": String(e.attrs.id),
						"data-inline": String(t),
						...!t && { style: "display: contents" }
					},
					0
				];
			},
			parseDOM: [{
				tag: "ins",
				getAttrs(e) {
					return e.dataset.id ? { id: parseInt(e.dataset.id, 10) } : !1;
				}
			}]
		} : {};
	}
}), Ar = k.create({
	name: "deletion",
	inclusive: !1,
	excludes: "insertion modification deletion",
	addAttributes() {
		return { id: {
			default: null,
			validate: "number"
		} };
	},
	extendMarkSchema(e) {
		return e.name === "deletion" ? {
			blocknoteIgnore: !0,
			inclusive: !1,
			toDOM(e, t) {
				return [
					"del",
					{
						"data-id": String(e.attrs.id),
						"data-inline": String(t),
						...!t && { style: "display: contents" }
					},
					0
				];
			},
			parseDOM: [{
				tag: "del",
				getAttrs(e) {
					return e.dataset.id ? { id: parseInt(e.dataset.id, 10) } : !1;
				}
			}]
		} : {};
	}
}), jr = k.create({
	name: "modification",
	inclusive: !1,
	excludes: "deletion insertion",
	addAttributes() {
		return {
			id: {
				default: null,
				validate: "number"
			},
			type: { validate: "string" },
			attrName: {
				default: null,
				validate: "string|null"
			},
			previousValue: { default: null },
			newValue: { default: null }
		};
	},
	extendMarkSchema(e) {
		return e.name === "modification" ? {
			blocknoteIgnore: !0,
			inclusive: !1,
			toDOM(e, t) {
				return [
					t ? "span" : "div",
					{
						"data-type": "modification",
						"data-id": String(e.attrs.id),
						"data-mod-type": e.attrs.type,
						"data-mod-prev-val": JSON.stringify(e.attrs.previousValue),
						"data-mod-new-val": JSON.stringify(e.attrs.newValue)
					},
					0
				];
			},
			parseDOM: [{
				tag: "span[data-type='modification']",
				getAttrs(e) {
					return e.dataset.id ? {
						id: parseInt(e.dataset.id, 10),
						type: e.dataset.modType,
						previousValue: e.dataset.modPrevVal,
						newValue: e.dataset.modNewVal
					} : !1;
				}
			}, {
				tag: "div[data-type='modification']",
				getAttrs(e) {
					return e.dataset.id ? {
						id: parseInt(e.dataset.id, 10),
						type: e.dataset.modType,
						previousValue: e.dataset.modPrevVal
					} : !1;
				}
			}]
		} : {};
	}
}), Mr = O.create({
	name: "textAlignment",
	addGlobalAttributes() {
		return [{
			types: ["tableCell", "tableHeader"],
			attributes: { textAlignment: {
				default: "left",
				parseHTML: (e) => e.getAttribute("data-text-alignment"),
				renderHTML: (e) => e.textAlignment === "left" ? {} : { "data-text-alignment": e.textAlignment }
			} }
		}];
	}
}), Nr = O.create({
	name: "blockTextColor",
	addGlobalAttributes() {
		return [{
			types: [
				"table",
				"tableCell",
				"tableHeader"
			],
			attributes: { textColor: de() }
		}];
	}
}), Pr = {
	blockColor: "data-block-color",
	blockStyle: "data-block-style",
	id: "data-id",
	depth: "data-depth",
	depthChange: "data-depth-change"
}, Fr = A.create({
	name: "blockContainer",
	group: "blockGroupChild bnBlock",
	content: "blockContent blockGroup?",
	priority: 50,
	defining: !0,
	marks: "insertion modification deletion",
	parseHTML() {
		return [{
			tag: "div[data-node-type=" + this.name + "]",
			getAttrs: (e) => {
				if (typeof e == "string") return !1;
				let t = {};
				for (let [n, r] of Object.entries(Pr)) e.getAttribute(r) && (t[n] = e.getAttribute(r));
				return t;
			}
		}, {
			tag: "div[data-node-type=\"blockOuter\"]",
			skip: !0
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		let t = document.createElement("div");
		t.className = "bn-block-outer", t.setAttribute("data-node-type", "blockOuter");
		for (let [n, r] of Object.entries(e)) n !== "class" && t.setAttribute(n, r);
		let n = {
			...this.options.domAttributes?.block || {},
			...e
		}, r = document.createElement("div");
		r.className = C("bn-block", n.class), r.setAttribute("data-node-type", this.name);
		for (let [e, t] of Object.entries(n)) e !== "class" && r.setAttribute(e, t);
		return t.appendChild(r), {
			dom: t,
			contentDOM: r
		};
	}
}), Ir = A.create({
	name: "blockGroup",
	group: "childContainer",
	content: "blockGroupChild+",
	marks: "deletion insertion modification",
	parseHTML() {
		return [{
			tag: "div",
			getAttrs: (e) => typeof e == "string" ? !1 : e.getAttribute("data-node-type") === "blockGroup" ? null : !1
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		let t = {
			...this.options.domAttributes?.blockGroup || {},
			...e
		}, n = document.createElement("div");
		n.className = C("bn-block-group", t.class), n.setAttribute("data-node-type", "blockGroup");
		for (let [e, r] of Object.entries(t)) e !== "class" && n.setAttribute(e, r);
		return {
			dom: n,
			contentDOM: n
		};
	}
}), Lr = A.create({
	name: "doc",
	topNode: !0,
	content: "blockGroup",
	marks: "insertion modification deletion"
}), Rr = pe(({ options: e }) => ({
	key: "collaboration",
	blockNoteExtensions: [
		me(e),
		ge(e),
		ye(e),
		Me(),
		ve(e)
	]
}));
//#endregion
//#region src/editor/managers/ExtensionManager/extensions.ts
function zr(e, t) {
	return [
		j.ClipboardTextSerializer,
		j.Commands,
		j.Editable,
		j.FocusEvents,
		j.Tabindex,
		_t,
		f.configure({
			types: [
				"blockContainer",
				"columnList",
				"column"
			],
			setIdAttribute: t.setIdAttribute,
			isWithinEditor: e.isWithinEditor
		}),
		Sr,
		vt,
		kr,
		Ar,
		jr,
		Kn.configure({
			HTMLAttributes: t.links?.HTMLAttributes ?? {},
			editor: e,
			onClick: t.links?.onClick,
			...t.links?.isValidLink ? { isValidLink: t.links.isValidLink } : {}
		}),
		...Object.values(e.schema.styleSpecs).map((t) => t.implementation.mark.configure({ editor: e })),
		Nr,
		xr,
		Mr,
		O.create({
			name: "OverrideEscape",
			addKeyboardShortcuts: () => ({ Escape: () => e.getExtension(ne)?.shown() ? !1 : (e.blur(), !0) })
		}),
		Lr,
		Fr.configure({
			editor: e,
			domAttributes: t.domAttributes
		}),
		Or.configure({
			editor: e,
			tabBehavior: t.tabBehavior
		}),
		Ir.configure({ domAttributes: t.domAttributes }),
		...Object.values(e.schema.inlineContentSpecs).filter((e) => e.config !== "link" && e.config !== "text").map((t) => t.implementation.node.configure({ editor: e })),
		...Object.values(e.schema.blockSpecs).flatMap((n) => [..."node" in n.implementation ? [n.implementation.node.configure({
			editor: e,
			domAttributes: t.domAttributes
		})] : []]),
		br(e),
		hr(e, t.pasteHandler || ((e) => e.defaultPasteHandler())),
		Qn(e)
	];
}
function Br(e, t) {
	let n = [
		he(),
		Ne(t),
		y(t),
		w(t),
		be(t),
		Te(),
		Oe(t),
		Pe(t),
		De(t),
		ne(t),
		...t.trailingBlock === !1 ? [] : [ke()]
	];
	return t.collaboration ? n.push(Rr(t.collaboration)) : n.push(je()), "table" in e.schema.blockSpecs && n.push(Ee(t)), t.animations !== !1 && n.push(Se()), n;
}
//#endregion
//#region src/editor/managers/ExtensionManager/index.ts
var Vr = class {
	disabledExtensions = /* @__PURE__ */ new Set();
	extensions = [];
	abortMap = /* @__PURE__ */ new Map();
	extensionFactories = /* @__PURE__ */ new Map();
	extensionPlugins = /* @__PURE__ */ new Map();
	constructor(e, t) {
		this.editor = e, this.options = t, e.onMount(() => {
			for (let t of this.extensions) if (t.mount) {
				let n = new window.AbortController(), r = t.mount({
					dom: e.prosemirrorView.dom,
					root: e.prosemirrorView.root,
					signal: n.signal
				});
				r && n.signal.addEventListener("abort", () => {
					r();
				}), this.abortMap.set(t, n);
			}
		}), e.onUnmount(() => {
			for (let [e, t] of this.abortMap.entries()) this.abortMap.delete(e), t.abort();
		}), this.disabledExtensions = new Set(t.disableExtensions || []);
		for (let e of Br(this.editor, this.options)) this.addExtension(e);
		for (let e of this.options.extensions ?? []) this.addExtension(e);
		for (let e of Object.values(this.editor.schema.blockSpecs)) for (let t of e.extensions ?? []) this.addExtension(t);
	}
	registerExtension(e) {
		let t = [].concat(e).filter(Boolean);
		if (!t.length) {
			console.warn("No extensions found to register", e);
			return;
		}
		let n = t.map((e) => this.addExtension(e)).filter(Boolean), r = /* @__PURE__ */ new Set();
		for (let e of n) e?.tiptapExtensions && console.warn(`Extension ${e.key} has tiptap extensions, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`, e), e?.inputRules?.length && console.warn(`Extension ${e.key} has input rules, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`, e), this.getProsemirrorPluginsFromExtension(e).plugins.forEach((e) => {
			r.add(e);
		});
		this.updatePlugins((e) => [...e, ...r]);
	}
	addExtension(e) {
		let t;
		if (t = typeof e == "function" ? e({ editor: this.editor }) : e, !(!t || this.disabledExtensions.has(t.key))) {
			if (typeof e == "function") {
				let e = t[fe];
				typeof e == "function" && this.extensionFactories.set(e, t);
			}
			if (this.extensions.push(t), t.blockNoteExtensions) for (let e of t.blockNoteExtensions) this.addExtension(e);
			return t;
		}
	}
	resolveExtensions(e) {
		let t = [];
		if (typeof e == "function") {
			let n = this.extensionFactories.get(e);
			n && t.push(n);
		} else if (Array.isArray(e)) for (let n of e) t.push(...this.resolveExtensions(n));
		else if (typeof e == "object" && "key" in e) t.push(e);
		else if (typeof e == "string") {
			let n = this.extensions.find((t) => t.key === e);
			n && t.push(n);
		}
		return t;
	}
	unregisterExtension(e) {
		let t = this.resolveExtensions(e);
		if (!t.length) {
			console.warn("No extensions found to unregister", e);
			return;
		}
		let n = !1, r = /* @__PURE__ */ new Set();
		for (let i of t) this.extensions = this.extensions.filter((e) => e !== i), this.extensionFactories.forEach((e, t) => {
			e === i && this.extensionFactories.delete(t);
		}), this.abortMap.get(i)?.abort(), this.abortMap.delete(i), this.extensionPlugins.get(i)?.forEach((e) => {
			r.add(e);
		}), this.extensionPlugins.delete(i), i.tiptapExtensions && !n && (n = !0, console.warn(`Extension ${i.key} has tiptap extensions, but they will not be removed. Please separate the extension into multiple extensions if you want to remove them, or re-initialize the editor.`, e));
		this.updatePlugins((e) => e.filter((e) => !r.has(e)));
	}
	updatePlugins(e) {
		let t = this.editor.prosemirrorState, n = t.reconfigure({ plugins: e(t.plugins.slice()) });
		this.editor.prosemirrorView.updateState(n);
	}
	getTiptapExtensions() {
		let e = zr(this.editor, this.options).filter((e) => !this.disabledExtensions.has(e.name)), t = d(this.extensions), n = /* @__PURE__ */ new Map();
		for (let r of this.extensions) {
			r.tiptapExtensions && e.push(...r.tiptapExtensions);
			let i = t(r.key), { plugins: a, inputRules: o } = this.getProsemirrorPluginsFromExtension(r);
			a.length && e.push(O.create({
				name: r.key,
				priority: i,
				addProseMirrorPlugins: () => a
			})), o.length && (n.has(i) || n.set(i, []), n.get(i).push(...o));
		}
		e.push(O.create({
			name: "blocknote-input-rules",
			addProseMirrorPlugins() {
				let e = [];
				return Array.from(n.keys()).sort().reverse().forEach((t) => {
					e.push(...n.get(t));
				}), [ht({ rules: e })];
			}
		}));
		for (let t of this.options._tiptapOptions?.extensions ?? []) e.push(t);
		return e;
	}
	getProsemirrorPluginsFromExtension(e) {
		let t = [...e.prosemirrorPlugins ?? []], n = [];
		return !e.prosemirrorPlugins?.length && !Object.keys(e.keyboardShortcuts || {}).length && !e.inputRules?.length ? {
			plugins: t,
			inputRules: n
		} : (this.extensionPlugins.set(e, t), e.inputRules?.length && n.push(...e.inputRules.map((e) => new mt(e.find, (t, n, r, i) => {
			let o = e.replace({
				match: n,
				range: {
					from: r,
					to: i
				},
				editor: this.editor
			});
			if (o) {
				let e = this.editor.getTextCursorPosition();
				if (this.editor.schema.blockSchema[e.block.type].content !== "inline") return null;
				let n = S(t.tr), s = t.tr.deleteRange(r, i);
				return a(s, n.bnBlock.beforePos, o), s;
			}
			return null;
		}))), Object.keys(e.keyboardShortcuts || {}).length && t.push(gt(Object.fromEntries(Object.entries(e.keyboardShortcuts).map(([e, t]) => [e, () => t({ editor: this.editor })])))), {
			plugins: t,
			inputRules: n
		});
	}
	getExtensions() {
		return new Map(this.extensions.map((e) => [e.key, e]));
	}
	getExtension(e) {
		if (typeof e == "string") return this.extensions.find((t) => t.key === e) || void 0;
		if (typeof e == "function") return this.extensionFactories.get(e) || void 0;
		throw Error(`Invalid extension type: ${typeof e}`);
	}
	hasExtension(e) {
		return typeof e == "string" ? this.extensions.some((t) => t.key === e) : typeof e == "object" && "key" in e ? this.extensions.some((t) => t.key === e.key) : typeof e == "function" ? this.extensionFactories.has(e) : !1;
	}
};
//#endregion
//#region src/util/expandToWords.ts
function Hr(e, t) {
	let { $from: n, $to: r } = t;
	if (n.pos > n.start() && n.pos < e.content.size) {
		let t = e.textBetween(n.pos, n.pos + 1);
		if (/^[\w\p{P}]$/u.test(t)) {
			let t = e.textBetween(n.start(), n.pos).match(/[\w\p{P}]+$/u);
			t && (n = e.resolve(n.pos - t[0].length));
		}
	}
	if (r.pos < r.end() && r.pos > 0) {
		let t = e.textBetween(r.pos - 1, r.pos);
		if (/^[\w\p{P}]$/u.test(t)) {
			let t = e.textBetween(r.pos, r.end()).match(/^[\w\p{P}]+/u);
			t && (r = e.resolve(r.pos + t[0].length));
		}
	}
	return {
		$from: n,
		$to: r,
		from: n.pos,
		to: r.pos
	};
}
//#endregion
//#region src/api/blockManipulation/selections/selection.ts
function Ur(e) {
	let t = x(e);
	if (e.selection.empty || "node" in e.selection) return;
	let n = e.doc.resolve(g(e.doc, e.selection.from).posBeforeNode), r = e.doc.resolve(g(e.doc, e.selection.to).posBeforeNode), i = (r, i) => {
		let a = n.posAtIndex(r, i), o = e.doc.resolve(a).nodeAfter;
		if (!o) throw Error(`Error getting selection - node not found at position ${a}`);
		return b(o, t);
	}, a = [], o = n.sharedDepth(r.pos), s = n.index(o), c = r.index(o);
	if (n.depth > o) {
		a.push(b(n.nodeAfter, t));
		for (let e = n.depth; e > o; e--) if (n.node(e).type.isInGroup("childContainer")) {
			let t = n.index(e) + 1, r = n.node(e).childCount;
			for (let n = t; n < r; n++) a.push(i(n, e));
		}
	} else a.push(i(s, o));
	for (let e = s + 1; e <= c; e++) a.push(i(e, o));
	if (a.length === 0) throw Error(`Error getting selection - selection doesn't span any blocks (${e.selection})`);
	return { blocks: a };
}
function Wr(e, t, n) {
	let a = typeof t == "string" ? t : t.id, o = typeof n == "string" ? n : n.id, s = le(x(e));
	if (a === o) throw Error(`Attempting to set selection with the same anchor and head blocks (id ${a})`);
	let c = i(a, e.doc);
	if (!c) throw Error(`Block with ID ${a} not found`);
	let l = i(o, e.doc);
	if (!l) throw Error(`Block with ID ${o} not found`);
	let u = v(c), d = v(l), f = s.blockSchema[u.blockNoteType], p = s.blockSchema[d.blockNoteType];
	if (!u.isBlockContainer || f.content === "none") throw Error(`Attempting to set selection anchor in block without content (id ${a})`);
	if (!d.isBlockContainer || p.content === "none") throw Error(`Attempting to set selection anchor in block without content (id ${o})`);
	let m, h;
	if (f.content === r) {
		let e = at.get(u.blockContent.node);
		m = u.blockContent.beforePos + e.positionAt(0, 0, u.blockContent.node) + 1 + 2;
	} else m = u.blockContent.beforePos + 1;
	if (p.content === r) {
		let t = at.get(d.blockContent.node), n = d.blockContent.beforePos + t.positionAt(t.height - 1, t.width - 1, d.blockContent.node) + 1;
		h = n + e.doc.resolve(n).nodeAfter.nodeSize - 2;
	} else h = d.blockContent.afterPos - 1;
	e.setSelection(F.create(e.doc, m, h));
}
function Gr(e, t = !1) {
	let n = x(e), r = t ? Hr(e.doc, e.selection) : e.selection, i = r.$from, a = r.$to;
	for (; a.parentOffset >= a.parent.nodeSize - 2 && a.depth > 0;) a = e.doc.resolve(a.pos + 1);
	for (; a.parentOffset === 0 && a.depth > 0;) a = e.doc.resolve(a.pos - 1);
	for (; i.parentOffset === 0 && i.depth > 0;) i = e.doc.resolve(i.pos - 1);
	for (; i.parentOffset >= i.parent.nodeSize - 2 && i.depth > 0;) i = e.doc.resolve(i.pos + 1);
	let o = ee(e.doc.slice(i.pos, a.pos, !0), n);
	return {
		_meta: {
			startPos: i.pos,
			endPos: a.pos
		},
		...o
	};
}
//#endregion
//#region src/api/blockManipulation/selections/textCursorPosition.ts
function Kr(e) {
	let { bnBlock: t } = S(e), n = x(e.doc), r = e.doc.resolve(t.beforePos), i = r.nodeBefore, a = e.doc.resolve(t.afterPos).nodeAfter, o;
	for (let e = r.depth; e > 0; e--) {
		let t = r.node(e);
		if (t.type.isInGroup("bnBlock")) {
			o = t;
			break;
		}
	}
	return {
		block: b(t.node, n),
		prevBlock: i === null ? void 0 : b(i, n),
		nextBlock: a === null ? void 0 : b(a, n),
		parentBlock: o === void 0 ? void 0 : b(o, n)
	};
}
function qr(e, t, a = "start") {
	let o = typeof t == "string" ? t : t.id, s = le(x(e.doc)), c = i(o, e.doc);
	if (!c) throw Error(`Block with ID ${o} not found`);
	let l = v(c), u = s.blockSchema[l.blockNoteType].content;
	if (l.isBlockContainer) {
		let t = l.blockContent;
		if (u === "none") {
			e.setSelection(N.create(e.doc, t.beforePos));
			return;
		}
		if (u === "inline") a === "start" ? e.setSelection(F.create(e.doc, t.beforePos + 1)) : e.setSelection(F.create(e.doc, t.afterPos - 1));
		else if (u === r) a === "start" ? e.setSelection(F.create(e.doc, t.beforePos + 4)) : e.setSelection(F.create(e.doc, t.afterPos - 4));
		else throw new n(u);
	} else qr(e, (a === "start" ? l.childContainer.node.firstChild : l.childContainer.node.lastChild).attrs.id, a);
}
//#endregion
//#region src/editor/managers/SelectionManager.ts
var Jr = class {
	constructor(e) {
		this.editor = e;
	}
	getSelection() {
		return this.editor.transact((e) => Ur(e));
	}
	getSelectionCutBlocks(e = !1) {
		return this.editor.transact((t) => Gr(t, e));
	}
	setSelection(e, t) {
		return this.editor.transact((n) => Wr(n, e, t));
	}
	getTextCursorPosition() {
		return this.editor.transact((e) => Kr(e));
	}
	setTextCursorPosition(e, t = "start") {
		return this.editor.transact((n) => qr(n, e, t));
	}
	getSelectionBoundingBox() {
		if (!this.editor.prosemirrorView) return;
		let { selection: e } = this.editor.prosemirrorState, { ranges: t } = e, n = Math.min(...t.map((e) => e.$from.pos)), r = Math.max(...t.map((e) => e.$to.pos));
		if (et(e)) {
			let e = this.editor.prosemirrorView.nodeDOM(n);
			if (e) return e.getBoundingClientRect();
		}
		return nt(this.editor.prosemirrorView, n, r).toJSON();
	}
}, Yr = class {
	constructor(e) {
		this.editor = e;
	}
	activeTransaction = null;
	can(e) {
		try {
			return this.isInCan = !0, e();
		} finally {
			this.isInCan = !1;
		}
	}
	isInCan = !1;
	exec(e) {
		if (this.activeTransaction) throw Error("`exec` should not be called within a `transact` call, move the `exec` call outside of the `transact` call");
		if (this.isInCan) return this.canExec(e);
		let t = this.prosemirrorState, n = this.prosemirrorView;
		return e(t, (e) => this.prosemirrorView.dispatch(e), n);
	}
	canExec(e) {
		if (this.activeTransaction) throw Error("`canExec` should not be called within a `transact` call, move the `canExec` call outside of the `transact` call");
		let t = this.prosemirrorState, n = this.prosemirrorView;
		return e(t, void 0, n);
	}
	transact(e) {
		if (this.activeTransaction) return e(this.activeTransaction);
		try {
			this.activeTransaction = this.editor._tiptapEditor.state.tr;
			let t = e(this.activeTransaction), n = this.activeTransaction;
			return this.activeTransaction = null, n && (n.docChanged || n.selectionSet || n.scrolledIntoView || n.storedMarksSet || !n.isGeneric) && this.prosemirrorView.dispatch(n), t;
		} finally {
			this.activeTransaction = null;
		}
	}
	get prosemirrorState() {
		if (this.activeTransaction) throw Error("`prosemirrorState` should not be called within a `transact` call, move the `prosemirrorState` call outside of the `transact` call or use `editor.transact` to read the current editor state");
		return this.editor._tiptapEditor.state;
	}
	get prosemirrorView() {
		return this.editor._tiptapEditor.view;
	}
	isFocused() {
		return this.prosemirrorView?.hasFocus() || !1;
	}
	focus() {
		this.prosemirrorView?.focus();
	}
	get isEditable() {
		if (!this.editor._tiptapEditor) {
			if (!this.editor.headless) throw Error("no editor, but also not headless?");
			return !1;
		}
		return this.editor._tiptapEditor.isEditable === void 0 ? !0 : this.editor._tiptapEditor.isEditable;
	}
	set isEditable(e) {
		if (!this.editor._tiptapEditor) {
			if (!this.editor.headless) throw Error("no editor, but also not headless?");
			return;
		}
		this.editor._tiptapEditor.options.editable !== e && this.editor._tiptapEditor.setEditable(e);
	}
	undo() {
		let e = this.editor.getExtension("yUndo");
		if (e) return this.exec(e.undoCommand);
		let t = this.editor.getExtension("history");
		if (t) return this.exec(t.undoCommand);
		throw Error("No undo plugin found");
	}
	redo() {
		let e = this.editor.getExtension("yUndo");
		if (e) return this.exec(e.redoCommand);
		let t = this.editor.getExtension("history");
		if (t) return this.exec(t.redoCommand);
		throw Error("No redo plugin found");
	}
};
//#endregion
//#region src/api/blockManipulation/insertContentAt.ts
function Xr(e, t, n, r = { updateSelection: !0 }) {
	let { from: i, to: a } = typeof t == "number" ? {
		from: t,
		to: t
	} : {
		from: t.from,
		to: t.to
	}, o = !0, s = !0, c = "";
	if (n.forEach((e) => {
		e.check(), o && e.isText && e.marks.length === 0 ? c += e.text : o = !1, s = s ? e.isBlock : !1;
	}), i === a && s) {
		let { parent: t } = e.doc.resolve(i);
		t.isTextblock && !t.type.spec.code && !t.childCount && (--i, a += 1);
	}
	return o ? e.insertText(c, i, a) : e.replaceWith(i, a, n), r.updateSelection && rt(e, e.steps.length - 1, -1), !0;
}
//#endregion
//#region src/editor/managers/StyleManager.ts
var Zr = class {
	constructor(e) {
		this.editor = e;
	}
	insertInlineContent(e, { updateSelection: t = !1 } = {}) {
		let n = ie(e, this.editor.pmSchema);
		this.editor.transact((e) => {
			Xr(e, {
				from: e.selection.from,
				to: e.selection.to
			}, n, { updateSelection: t });
		});
	}
	getActiveStyles() {
		return this.editor.transact((e) => {
			let t = {}, n = e.selection.$to.marks();
			for (let e of n) {
				let n = this.editor.schema.styleSchema[e.type.name];
				if (!n) {
					e.type.name !== "link" && !e.type.spec.blocknoteIgnore && console.warn("mark not found in styleschema", e.type.name);
					continue;
				}
				n.propSchema === "boolean" ? t[n.type] = !0 : t[n.type] = e.attrs.stringValue;
			}
			return t;
		});
	}
	addStyles(e) {
		for (let [t, r] of Object.entries(e)) {
			let e = this.editor.schema.styleSchema[t];
			if (!e) throw Error(`style ${t} not found in styleSchema`);
			if (e.propSchema === "boolean") this.editor._tiptapEditor.commands.setMark(t);
			else if (e.propSchema === "string") this.editor._tiptapEditor.commands.setMark(t, { stringValue: r });
			else throw new n(e.propSchema);
		}
	}
	removeStyles(e) {
		for (let t of Object.keys(e)) this.editor._tiptapEditor.commands.unsetMark(t);
	}
	toggleStyles(e) {
		for (let [t, r] of Object.entries(e)) {
			let e = this.editor.schema.styleSchema[t];
			if (!e) throw Error(`style ${t} not found in styleSchema`);
			if (e.propSchema === "boolean") this.editor._tiptapEditor.commands.toggleMark(t);
			else if (e.propSchema === "string") this.editor._tiptapEditor.commands.toggleMark(t, { stringValue: r });
			else throw new n(e.propSchema);
		}
	}
	getSelectedText() {
		return this.editor.transact((e) => e.doc.textBetween(e.selection.from, e.selection.to));
	}
	getLinkMarkAtPos(e) {
		return this.editor.transact((t) => {
			let n = t.doc.resolve(e), r = n.marks().find((e) => e.type.name === "link");
			if (!r) return;
			let i = Ze(n, r.type);
			if (i) return {
				href: r.attrs.href,
				from: i.from,
				to: i.to,
				text: t.doc.textBetween(i.from, i.to)
			};
		});
	}
	getSelectedLinkUrl() {
		return this.editor.transact((e) => this.getLinkMarkAtPos(e.selection.from)?.href);
	}
	createLink(e, t) {
		e !== "" && this.editor.transact((n) => {
			let { from: r, to: i } = n.selection, a = this.editor.pmSchema.mark("link", { href: e });
			t ? n.insertText(t, r, i).addMark(r, r + t.length, a) : n.addMark(r, i, a);
		});
	}
	editLink(e, t, n = this.editor.transact((e) => e.selection.anchor)) {
		this.editor.transact((r) => {
			let { from: i, to: a } = this.getLinkMarkAtPos(n + 1) || {
				from: r.selection.from,
				to: r.selection.to
			}, o = this.editor.pmSchema.mark("link", { href: e });
			t !== r.doc.textBetween(i, a) && r.insertText(t, i, a), r.addMark(i, i + t.length, o);
		}), this.editor.prosemirrorView.focus();
	}
	deleteLink(e = this.editor.transact((e) => e.selection.anchor)) {
		this.editor.transact((t) => {
			let { from: n, to: r } = this.getLinkMarkAtPos(e + 1) || {
				from: t.selection.from,
				to: t.selection.to
			};
			t.removeMark(n, r, this.editor.pmSchema.marks.link).setMeta("preventAutolink", !0);
		}), this.editor.prosemirrorView.focus();
	}
};
//#endregion
//#region src/editor/transformPasted.ts
function Qr(e) {
	return Je(e.state.selection.$from, (e) => e.type.name === "tableCell" || e.type.name === "tableHeader") !== void 0;
}
function $r(e, t) {
	let n = t.nodes.hardBreak, r = I.empty;
	return e.forEach((e) => {
		e.isTextblock && e.childCount > 0 ? (r = r.append(e.content), r = r.addToEnd(n.create())) : e.isText ? r = r.addToEnd(e) : e.isBlock && e.childCount > 0 && (r = r.append($r(e.content, t)), r = r.addToEnd(n.create()));
	}), r.lastChild?.type === n && (r = r.cut(0, r.size - 1)), r;
}
function ei(e, t) {
	let n = [];
	return e.forEach((e, r, i) => {
		i !== t && n.push(e);
	}), I.from(n);
}
function ti(e, t) {
	let n = [];
	for (let r = 0; r < e.childCount; r++) if (e.child(r).type.name === "tableRow") if (n.length > 0 && n[n.length - 1].type.name === "table") {
		let t = n[n.length - 1], i = t.copy(t.content.addToEnd(e.child(r)));
		n[n.length - 1] = i;
	} else {
		let i = t.nodes.table.createChecked(void 0, e.child(r));
		n.push(i);
	}
	else n.push(e.child(r));
	return e = I.from(n), e;
}
function ni(e, t) {
	let n = I.from(e.content);
	if (n = ti(n, t.state.schema), Qr(t)) {
		let e = !1;
		if (n.descendants((t) => {
			t.type.isInGroup("tableContent") && (e = !0);
		}), !e && !t.state.schema.nodes.tableParagraph.validContent(n)) return new L($r(n, t.state.schema), 0, 0);
	}
	if (!ri(n, t)) return new L(n, e.openStart, e.openEnd);
	for (let e = 0; e < n.childCount; e++) if (n.child(e).type.spec.group === "blockContent") {
		let r = [n.child(e)];
		if (e + 1 < n.childCount && n.child(e + 1).type.name === "blockGroup") {
			let t = n.child(e + 1).child(0).child(0);
			(t.type.name === "bulletListItem" || t.type.name === "numberedListItem" || t.type.name === "checkListItem") && (r.push(n.child(e + 1)), n = ei(n, e + 1));
		}
		let i = t.state.schema.nodes.blockContainer.createChecked(void 0, r);
		n = n.replaceChild(e, i);
	}
	return new L(n, e.openStart, e.openEnd);
}
function ri(e, t) {
	let n = e.childCount === 1, r = e.firstChild?.type.spec.content === "inline*", i = e.firstChild?.type.spec.content === "tableRow+";
	if (n) {
		if (r) return !1;
		if (i) {
			let e = p(t.state);
			if (e.isBlockContainer) return e.blockContent.node.type.spec.content !== "tableRow+";
		}
	}
	return !0;
}
//#endregion
//#region src/editor/BlockNoteEditor.ts
var ii = {
	enableInputRules: !0,
	enablePasteRules: !0,
	enableCoreExtensions: !1
}, ai = class e extends Ie {
	pmSchema;
	_tiptapEditor;
	elementRenderer = null;
	blockCache = /* @__PURE__ */ new WeakMap();
	dictionary;
	schema;
	blockImplementations;
	inlineContentImplementations;
	styleImplementations;
	uploadFile;
	onUploadStartCallbacks = [];
	onUploadEndCallbacks = [];
	resolveFileUrl;
	settings;
	static create(t) {
		return new e(t ?? {});
	}
	constructor(e) {
		super(), this.options = e, this.dictionary = e.dictionary || Fe, this.settings = { tables: {
			splitCells: e?.tables?.splitCells ?? !1,
			cellBackgroundColor: e?.tables?.cellBackgroundColor ?? !1,
			cellTextColor: e?.tables?.cellTextColor ?? !1,
			headers: e?.tables?.headers ?? !1
		} };
		let n = {
			defaultStyles: !0,
			schema: e.schema || ce.create(),
			...e,
			placeholders: {
				...this.dictionary.placeholders,
				...e.placeholders
			}
		};
		if (this.schema = n.schema, this.blockImplementations = n.schema.blockSpecs, this.inlineContentImplementations = n.schema.inlineContentSpecs, this.styleImplementations = n.schema.styleSpecs, n.uploadFile) {
			let e = n.uploadFile;
			this.uploadFile = async (t, n) => {
				this.onUploadStartCallbacks.forEach((e) => e.apply(this, [n]));
				try {
					return await e(t, n);
				} finally {
					this.onUploadEndCallbacks.forEach((e) => e.apply(this, [n]));
				}
			};
		}
		this.resolveFileUrl = n.resolveFileUrl, this._eventManager = new nn(this), this._extensionManager = new Vr(this, n);
		let r = this._extensionManager.getTiptapExtensions(), i = this._extensionManager.hasExtension("ySync") || this._extensionManager.hasExtension("liveblocksExtension");
		i && n.initialContent && console.warn("When using Collaboration, initialContent might cause conflicts, because changes should come from the collaboration provider");
		let a = {
			...ii,
			...n._tiptapOptions,
			element: null,
			autofocus: n.autofocus ?? !1,
			extensions: r,
			editorProps: {
				...n._tiptapOptions?.editorProps,
				attributes: {
					tabIndex: "0",
					...n._tiptapOptions?.editorProps?.attributes,
					...n.domAttributes?.editor,
					class: C("bn-editor", n.defaultStyles ? "bn-default-styles" : "", n.domAttributes?.editor?.class || "")
				},
				transformPasted: ni
			}
		};
		try {
			let e = n.initialContent || (i ? [{
				type: "paragraph",
				id: "initialBlockId"
			}] : [{
				type: "paragraph",
				id: f.options.generateID()
			}]);
			if (!Array.isArray(e) || e.length === 0) throw Error("initialContent must be a non-empty array of blocks, received: " + e);
			let r = $e(a.extensions);
			r.cached.blockNoteEditor = this;
			let o = Ke({
				type: "doc",
				content: [{
					type: "blockGroup",
					content: e.map((e) => t(e, r, this.schema.styleSchema).toJSON())
				}]
			}, r, a.parseOptions);
			this._tiptapEditor = new We({
				...a,
				content: o.toJSON()
			}), this.pmSchema = this._tiptapEditor.schema;
		} catch (e) {
			throw Error("Error creating document from blocks passed as `initialContent`", { cause: e });
		}
		let o, s = this.pmSchema.nodes.doc.createAndFill;
		this.pmSchema.nodes.doc.createAndFill = (...e) => {
			if (o) return o;
			let t = s.apply(this.pmSchema.nodes.doc, e), n = JSON.parse(JSON.stringify(t.toJSON()));
			return n.content[0].content[0].attrs.id = "initialBlockId", o = ze.fromJSON(this.pmSchema, n), o;
		}, this.pmSchema.cached.blockNoteEditor = this, this._tiptapEditor.on("mount", () => {
			this.headless = !1;
		}), this._tiptapEditor.on("unmount", () => {
			this.headless = !0;
		}), this._blockManager = new tn(this), this._exportManager = new vn(this), this._selectionManager = new Jr(this), this._stateManager = new Yr(this), this._styleManager = new Zr(this), this.emit("create");
	}
	_blockManager;
	_eventManager;
	_exportManager;
	_extensionManager;
	_selectionManager;
	_stateManager;
	_styleManager;
	get extensions() {
		return this._extensionManager.getExtensions();
	}
	exec(e) {
		return this._stateManager.exec(e);
	}
	canExec(e) {
		return this._stateManager.canExec(e);
	}
	transact(e) {
		return this._stateManager.transact(e);
	}
	unregisterExtension = (...e) => this._extensionManager.unregisterExtension(...e);
	registerExtension = (...e) => this._extensionManager.registerExtension(...e);
	getExtension = ((...e) => this._extensionManager.getExtension(...e));
	mount = (e) => {
		let t = e.getRootNode();
		typeof ShadowRoot < "u" && t instanceof ShadowRoot ? t.appendChild(this.portalElement) : document.body.appendChild(this.portalElement), this._tiptapEditor.mount({ mount: e });
	};
	unmount = () => {
		this.portalElement?.remove(), this._tiptapEditor.unmount();
	};
	get prosemirrorState() {
		return this._stateManager.prosemirrorState;
	}
	get prosemirrorView() {
		return this._stateManager.prosemirrorView;
	}
	get domElement() {
		if (!this.headless) return this.prosemirrorView?.dom;
	}
	_portalElement;
	get portalElement() {
		if (typeof document > "u") throw Error("Portal element accessed, but not available in headless mode");
		return this._portalElement ||= document.createElement("div"), this._portalElement;
	}
	isWithinEditor = (e) => !!(this.domElement?.parentElement?.contains(e) || this.portalElement?.contains(e));
	isFocused() {
		return this.headless ? !1 : this.prosemirrorView?.hasFocus() || !1;
	}
	headless = !0;
	focus() {
		this.headless || this.prosemirrorView.focus();
	}
	blur() {
		this.headless || this.domElement?.blur();
	}
	onUploadStart(e) {
		return this.onUploadStartCallbacks.push(e), () => {
			let t = this.onUploadStartCallbacks.indexOf(e);
			t > -1 && this.onUploadStartCallbacks.splice(t, 1);
		};
	}
	onUploadEnd(e) {
		return this.onUploadEndCallbacks.push(e), () => {
			let t = this.onUploadEndCallbacks.indexOf(e);
			t > -1 && this.onUploadEndCallbacks.splice(t, 1);
		};
	}
	get topLevelBlocks() {
		return this.document;
	}
	get document() {
		return this._blockManager.document;
	}
	getBlock(e) {
		return this._blockManager.getBlock(e);
	}
	getPrevBlock(e) {
		return this._blockManager.getPrevBlock(e);
	}
	getNextBlock(e) {
		return this._blockManager.getNextBlock(e);
	}
	getParentBlock(e) {
		return this._blockManager.getParentBlock(e);
	}
	forEachBlock(e, t = !1) {
		this._blockManager.forEachBlock(e, t);
	}
	onEditorContentChange(e) {
		this._tiptapEditor.on("update", e);
	}
	onEditorSelectionChange(e) {
		this._tiptapEditor.on("selectionUpdate", e);
	}
	onBeforeChange(e) {
		return this._extensionManager.getExtension(he).subscribe(e);
	}
	getTextCursorPosition() {
		return this._selectionManager.getTextCursorPosition();
	}
	setTextCursorPosition(e, t = "start") {
		return this._selectionManager.setTextCursorPosition(e, t);
	}
	getSelection() {
		return this._selectionManager.getSelection();
	}
	getSelectionCutBlocks(e = !1) {
		return this._selectionManager.getSelectionCutBlocks(e);
	}
	setSelection(e, t) {
		return this._selectionManager.setSelection(e, t);
	}
	get isEditable() {
		return this._stateManager.isEditable;
	}
	set isEditable(e) {
		this._stateManager.isEditable = e;
	}
	insertBlocks(e, t, n = "before") {
		return this._blockManager.insertBlocks(e, t, n);
	}
	updateBlock(e, t) {
		return this._blockManager.updateBlock(e, t);
	}
	removeBlocks(e) {
		return this._blockManager.removeBlocks(e);
	}
	replaceBlocks(e, t) {
		return this._blockManager.replaceBlocks(e, t);
	}
	undo() {
		return this._stateManager.undo();
	}
	redo() {
		return this._stateManager.redo();
	}
	insertInlineContent(e, { updateSelection: t = !1 } = {}) {
		this._styleManager.insertInlineContent(e, { updateSelection: t });
	}
	getActiveStyles() {
		return this._styleManager.getActiveStyles();
	}
	addStyles(e) {
		this._styleManager.addStyles(e);
	}
	removeStyles(e) {
		this._styleManager.removeStyles(e);
	}
	toggleStyles(e) {
		this._styleManager.toggleStyles(e);
	}
	getSelectedText() {
		return this._styleManager.getSelectedText();
	}
	getSelectedLinkUrl() {
		return this._styleManager.getSelectedLinkUrl();
	}
	createLink(e, t) {
		this._styleManager.createLink(e, t);
	}
	getLinkMarkAtPos(e) {
		return this._styleManager.getLinkMarkAtPos(e);
	}
	editLink(e, t, n) {
		this._styleManager.editLink(e, t, n);
	}
	deleteLink(e) {
		this._styleManager.deleteLink(e);
	}
	canNestBlock() {
		return this._blockManager.canNestBlock();
	}
	nestBlock() {
		this._blockManager.nestBlock();
	}
	canUnnestBlock() {
		return this._blockManager.canUnnestBlock();
	}
	unnestBlock() {
		this._blockManager.unnestBlock();
	}
	moveBlocksUp() {
		return this._blockManager.moveBlocksUp();
	}
	moveBlocksDown() {
		return this._blockManager.moveBlocksDown();
	}
	blocksToHTMLLossy(e = this.document) {
		return this._exportManager.blocksToHTMLLossy(e);
	}
	blocksToFullHTML(e = this.document) {
		return this._exportManager.blocksToFullHTML(e);
	}
	tryParseHTMLToBlocks(e) {
		return this._exportManager.tryParseHTMLToBlocks(e);
	}
	blocksToMarkdownLossy(e = this.document) {
		return this._exportManager.blocksToMarkdownLossy(e);
	}
	tryParseMarkdownToBlocks(e) {
		return this._exportManager.tryParseMarkdownToBlocks(e);
	}
	onChange(e, t) {
		return this._eventManager.onChange(e, t);
	}
	onSelectionChange(e, t) {
		return this._eventManager.onSelectionChange(e, t);
	}
	onMount(e) {
		return this._eventManager.onMount(e);
	}
	onUnmount(e) {
		return this._eventManager.onUnmount(e);
	}
	getSelectionBoundingBox() {
		return this._selectionManager.getSelectionBoundingBox();
	}
	get isEmpty() {
		let e = this.document;
		return e.length === 0 || e.length === 1 && e[0].type === "paragraph" && e[0].content.length === 0;
	}
	pasteHTML(e, t = !1) {
		this._exportManager.pasteHTML(e, t);
	}
	pasteText(e) {
		return this._exportManager.pasteText(e);
	}
	pasteMarkdown(e) {
		return this._exportManager.pasteMarkdown(e);
	}
}, oi = class {
	constructor(e, t, n) {
		this.mappings = t, this.options = n;
	}
	async resolveFile(e) {
		if (!this.options?.resolveFileUrl) return (await fetch(e)).blob();
		let t = await this.options.resolveFileUrl(e);
		return t instanceof Blob ? t : (await fetch(t)).blob();
	}
	mapStyles(e) {
		return Object.entries(e).map(([e, t]) => this.mappings.styleMapping[e](t, this));
	}
	mapInlineContent(e) {
		return this.mappings.inlineContentMapping[e.type](e, this);
	}
	transformInlineContent(e) {
		return e.map((e) => this.mapInlineContent(e));
	}
	async mapBlock(e, t, n, r) {
		return this.mappings.blockMapping[e.type](e, this, t, n, r);
	}
};
//#endregion
//#region src/exporter/mapping.ts
function si(e) {
	return {
		createBlockMapping: (e) => e,
		createInlineContentMapping: (e) => e,
		createStyleMapping: (e) => e
	};
}
//#endregion
//#region src/util/combineByGroup.ts
function ci(e, ...t) {
	let n = [...e];
	for (let e of t) for (let t of e) {
		let e = n.findLastIndex((e) => e.group === t.group);
		e === -1 ? n.push(t) : n.splice(e + 1, 0, t);
	}
	return n;
}
//#endregion
export { yt as C, bt as S, V as _, Hr as a, Ct as b, q as c, $t as d, en as f, H as g, U as h, ai as i, K as l, It as m, si as n, _r as o, Qt as p, oi as r, _n as s, ci as t, Zt as u, Tt as v, St as x, wt as y };

//# sourceMappingURL=src-iKYSBgjS.js.map